// @flow

import React, { Component } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import { hot } from 'react-hot-loader'
import './styles.scss'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import Masthead from '@ta-interaktiv/react-masthead'
import { Footer } from 'components/footer'
import Cover from 'components/cover'
import UserFeedback from '@ta-interaktiv/react-user-feedback'
import { ThemeSwitch as themeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Waypoint } from 'react-waypoint'
import Tipp from 'components/tipp'
import Scrollchor from 'react-scrollchor'

const ARTICLE_ID = '13330900'

// region Images
const mobilitaet = require('./mobilitaet.jpg?sizes=640w+800w+1280w+1600w')
const wohnen = require('./wohnen.jpg?sizes=640w+800w+1280w+1600w')
const konsum = require('./konsum.jpg?sizes=640w+800w+1280w+1600w')
const ernaehrung = require('./ernaehrung.jpg?sizes=640w+800w+1280w+1600w')
const diverses = require('./diverses.jpg?sizes=640w+800w+1280w+1600w')

// no-unused-vars
const sizesForTextContainer = '(max-width: 599px): 95vw, 581px'
// endregion

type Props = {}

type State = {
  isLoading: boolean,
  publicationDate: number
}

class AppComponent extends Component<Props, State> {
  state = {
    isLoading: true,
    publicationDate: Date.now() / 1000
  }

  constructor(props) {
    super(props)
    this.trackNavClicks = this.trackNavClicks.bind(this)
    // TODO Change if you want to use a different style sheet from
    // interaktiv.tagesanzeiger.ch/static/themes/
    themeSwitch({ mediaName: 'dasmagazin' })
  }

  trackNavClicks(e) {
    let clickedText = e.currentTarget.firstChild.nodeValue
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'question: ' + clickedText
    })
  }

  componentDidMount() {
    const domain = parseHostname().publicationDomain
    return fetch(`https://m.${domain}/api/articles/${ARTICLE_ID}`)
      .then(response => response.json())
      .then(data => {
        this.setState({
          publicationDate: data.article.first_published_at,
          isLoading: false
        })
      })
      .catch(error => {
        console.warn(error)
      })
  }

  render() {
    return (
      <div className='index'>
        <Masthead
          inverted
          articleId={ARTICLE_ID}
          mediaName={'dasmagazin'}
          fullMediaName={'Das Magazin'}
          homepage={'https://www.dasmagazin.ch'}
        />
        <header className='ui vertical fitted segment first'>
          <div
            className='ui inverted segment'
            style={{
              margin: 0,
              position: 'absolute',
              backgroundColor: 'transparent',
              zIndex: 99,
              width: '100%'
            }}
          >

          </div>
          <Cover
            title='75 Ideen, wie Sie den Klimawandel stoppen können'
            subtitle='Eine Anleitung zur Rettung der Welt.'
            author='Von Mathias Plüss'
          />
          <figcaption className='ui container'>
            Nichts schadet unserem Planeten mehr als das{' '}
            <Scrollchor animate={{ offset: -10 }} to='#fliegen'>
              &rarr;Fliegen
            </Scrollchor>
            , und auf nichts lässt sich leichter verzichten. (Bild: Tom Hendry /
            EyeEm)
          </figcaption>
        </header>

        <Waypoint scrollableAncestor={window} onLeave={(event) => {
          if (event.currentPosition === Waypoint.above) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              'event': 'startReading'
            }
            )
          }
        }} />

        <div className='ui text container'>
          <p>
            Eine kurze Rechnung zu Beginn, um die Dringlichkeit klarzumachen:
            Jede Schweizerin, jeder Schweizer verursacht pro Jahr etwa 14 Tonnen
            CO<sub>2</sub>-Emissionen. Wenn wir den Klimawandel stoppen wollen,
            dürften es allerhöchstens 1,5 Tonnen sein. Das bedeutet, dass wir
            unseren Ausstoss um 90 Prozent reduzieren müssen. Mindestens.
          </p>
          <p>
            Natürlich braucht es dazu technische und politische Massnahmen.
            Zuallererst aber muss jeder und jede bei sich selber anfangen. Viele
            Menschen haben sich das Ausmass des Problems noch überhaupt nicht
            bewusst gemacht, geschweige denn begonnen, ihren Lebensstil zu
            ändern. Dafür ist es höchste Zeit. Jedes Jahr Verzögerung macht es
            schwieriger, den Klimawandel zu bremsen.
          </p>
          <p>
            Die grössten Posten in Schweizer Haushalten lassen sich in folgende
            Bereich unterteilen:
          </p>
          <ul className='nav' id='nav'>
            <Scrollchor animate={{ offset: -40 }} to='#mobilitaet'>
              <li onClick={this.trackNavClicks}>
                Mobilität <i className='tiny icon chevron down' />
              </li>
            </Scrollchor>
            <Scrollchor animate={{ offset: -40 }} to='#wohnen'>
              <li onClick={this.trackNavClicks}>
                Wohnen <i className='tiny icon chevron down' />
              </li>
            </Scrollchor>
            <Scrollchor animate={{ offset: -40 }} to='#konsum'>
              <li onClick={this.trackNavClicks}>
                Konsum & Freizeit <i className='tiny icon chevron down' />
              </li>
            </Scrollchor>
            <Scrollchor animate={{ offset: -40 }} to='#ernaehrung'>
              <li onClick={this.trackNavClicks}>
                Ernährung <i className='tiny icon chevron down' />
              </li>
            </Scrollchor>
            <Scrollchor animate={{ offset: -40 }} to='#diverses'>
              <li
                onClick={this.trackNavClicks}
                style={{ borderBottom: '1px solid #ccc' }}
              >
                Kommunikation & Diverses{' '}
                <i className='tiny icon chevron down' />
              </li>
            </Scrollchor>
          </ul>
          <p>
            Die einzelnen Einträge sind mit Impact-Faktoren versehen: von{' '}
            <strong>❋</strong> bis <strong>❋❋❋❋❋</strong>. Fünf Sterne bedeuten:
            Hier können Sie sehr viel Einfluss nehmen. Einer bedeutet: Dieses
            Thema ist nicht ganz so wichtig, oder der Einzelne kann nicht viel
            ausrichten. Bei Auswahl und Bewertung haben wir uns vor allem am
            Klimawandel und am Schwund der Biodiversität orientiert, den beiden
            drängendsten Problemen.
          </p>
        </div>

        <figure className={'ui vertical padded segment'}>
          <img
            src={mobilitaet.sources['1280w']}
            srcSet={mobilitaet.srcSet}
            sizes={'100vw'}
            alt='Die meisten Autos in der Schweiz sind nicht nur überflüssig, sondern auch übermotorisiert.'
            className='ui fluid image'
          />
          <figcaption className='ui container'>
            Die meisten Autos in der Schweiz sind nicht nur überflüssig, sondern
            auch übermotorisiert{' '}
            <Scrollchor animate={{ offset: -10 }} to='#autogroesse'>
              [&rarr;Autogrösse]
            </Scrollchor>
            . (Bild: Getty Images)
          </figcaption>
        </figure>

        <Waypoint scrollableAncestor={window} onEnter={(event) => {
          if (event.previousPosition === Waypoint.below) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              'event': '10ContentRead'
            }
            )
          }
        }} />


        <div className='ui tipps container' id='mobilitaet'>
          <h2>Mobilität</h2>
          <div className='ui three column doubling stackable masonry grid'>
            <div className='column'>
              <div className='ui fluid card' id='autofahren'>
                <Tipp title='Autofahren' impact='❋❋❋❋❋'>
                  Der Verkehr ist die grösste Quelle von Treibhausgasen in der
                  Schweiz. Im Gegensatz zu anderen Bereichen wie etwa der
                  Industrie hat hier der Ausstoss in den letzten Jahren kaum
                  abgenommen. Für viele Leute ist Autofahren derart
                  selbstverständlich, dass sie sich nicht im Traum vorstellen
                  können, jemals damit aufzuhören. Trotzdem: Versuchen Sie es.
                  Machen Sie einen Anfang{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#ziele-setzen'>
                    [&rarr;Ziele setzen]
                  </Scrollchor>
                  . Am besten bei Routinefahrten – zur Arbeit, zum Einkaufen,
                  ins Training, da schenkt es ein. Wer es schafft, mit dem ÖV
                  oder mit dem Velo zu pendeln statt mit dem Auto, reduziert
                  seinen gesamten Klimagas-Ausstoss im Schnitt um volle 10
                  Prozent.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card' id='fliegen'>
                <Tipp title='Fliegen' impact='❋❋❋❋❋'>
                  Im Flugverhalten manifestiert sich der Irrsinn unserer Zeit in
                  seiner reinsten Form.
                  <ul>
                    <li>
                      1. Wohnen, heizen, essen müssen wir. Fliegen müssen wir
                      nicht. 86 Prozent der Flüge von Schweizerinnen und
                      Schweizern sind Privatreisen – sie geschehen also
                      mehrheitlich zu unserem Vergnügen. In keinem anderen
                      Gebiet liesse sich ebenso schmerzlos ebenso viel einsparen
                      wie beim Fliegen.
                    </li>
                    <li>
                      2. Fliegen ist unglaublich schädlich. Jeder Retourflug
                      über den Atlantik lässt, grob gerechnet, pro Passagier
                      etwa eine Tonne Gletschereis abschmelzen. Jährlich. Und
                      das für viele Jahrzehnte, denn das Kohlendioxid verweilt
                      sehr lange in der Atmosphäre.
                    </li>
                    <li>
                      3. Fliegen lässt sich nicht mit grünem Lifestyle
                      wettmachen. Selbst wer in einer Höhle lebt und nur selbst
                      geflochtene Bastkleider trägt, hat eine schlechte
                      Klimabilanz, wenn er dafür um die Welt jettet.
                    </li>
                  </ul>
                  Keine Frage, wir müssen aufhören damit{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#ziele-setzen'>
                    [&rarr;Ziele setzen]
                  </Scrollchor>
                  . Aber es geschieht das Gegenteil, die Flugkurven gehen steil
                  nach oben. Allein zwischen 2010 und 2015 stieg in der Schweiz
                  die Zahl der Flugkilometer pro Person um 57 Prozent. Und es
                  geht weiter: Im Januar 2019 absolvierte die Swiss (inklusive
                  Edelweiss) 7 Prozent mehr Flüge als im Januar 2018,
                  transportierte 8 Prozent mehr Passagiere und verkaufte 16
                  Prozent mehr Sitzkilometer.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Langstreckenflüge' impact='❋❋❋❋❋'>
                  Müssen zum absoluten Luxusgut werden. Es ist kein guter Grund,
                  irgendwohin zu reisen, bloss weil es dafür grad Tickets zum
                  Preis einer Pizza Margherita gibt. Wenn da ein fernes Land
                  ist, das Sie anzieht: Fliegen Sie hin! Aber nicht heute.
                  Sondern in zwei, drei, ja vielleicht erst in vier, fünf
                  Jahren. Sparen Sie bis dahin möglichst viele Ferientage an,
                  damit es sich wirklich lohnt. Von einem Kurztrip mit Jetlag
                  und Hotel-Hopping haben weder Sie noch das besuchte Land
                  etwas. Beginnen Sie ruhig jetzt schon zu lesen, sich
                  vorzubereiten, sich zu freuen. Und geniessen Sie es, in der
                  Zwischenzeit auf dem Boden zu bleiben.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Kurzstreckenflüge' impact='❋❋❋❋'>
                  Das Bild der Schweiz als Bahnfahrernation ist überholt: In den
                  letzten Jahren sind wir zum Vielfliegervolk geworden. Mit dem
                  Flugzeug legen wir mehr als doppelt so viele Kilometer zurück
                  wie mit dem Zug. Und wir fliegen doppelt so oft wie Deutsche
                  oder Franzosen. Nur Norweger und Iren haben eine ähnlich
                  schlechte Flugökobilanz wie die Schweizer. Norweger und Iren
                  aber leben, mit Verlaub, ein wenig abseits, wir hingegen im
                  Zentrum Europas. Die allermeisten europäischen
                  Touristenhotspots können wir problemlos mit dem Zug oder{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#car'>
                    &rarr;Car
                  </Scrollchor>{' '}
                  erreichen. Oft günstig, wenn man rechtzeitig bucht. Und man
                  erspart sich den ganzen Flughafenstress. Ein paar ausgewählte
                  Reisezeiten mit dem Zug ab Basel: Paris 3 Stunden, Brüssel und
                  London 6 Stunden, Berlin und Rom 7,5 Stunden, Wien und Prag 9
                  Stunden, Barcelona 10 Stunden, Glasgow 11 Stunden, Budapest 12
                  Stunden, Kopenhagen 13 Stunden. Es fahren auch direkte
                  Nachtzüge ab der Schweiz, zum Beispiel nach Berlin, Wien,
                  Prag, Budapest, Hamburg, Bremen, Graz, Zagreb und Belgrad.
                  Selbst das Auto ist aus Umweltsicht deutlich besser als das
                  Flugzeug – insbesondere, wenn mehr als eine Person mitfährt.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card' id='autogroesse'>
                <Tipp title='Autogrösse' impact='❋❋❋'>
                  Die Schweizer lieben grosse, starke Autos. Die Modelle mit der
                  kleinsten PS-Zahl werden bei uns gar nicht erst angeboten. Die
                  Neuwagen werden von Jahr zu Jahr schwerer, der 4x4-Anteil ist
                  auf Rekordniveau. Die Vorzüge dieser Grosskaliber kommen nur
                  selten zum Tragen – vielleicht zwei-, dreimal im Jahr, wenn
                  man ein Klavier kaufen will oder auf dem Weg in die Skiferien
                  mit viel Gepäck eine schneebedeckte Strasse hochfährt. Für den
                  Alltag hingegen sind diese Autos überdimensioniert und haben
                  einen schlechten Wirkungsgrad, weil sie permanent unterfordert
                  sind. Kaufen Sie darum ein leichtes Auto mit wenig PS: Es ist
                  stark genug. In den wenigen Fällen, wo Sie wirklich ein
                  grösseres Auto brauchen, können Sie eines mieten. Insgesamt
                  fährt man mit diesem Konzept nicht nur umweltfreundlicher,
                  sondern auch deutlich billiger. Die ökologischsten Automodelle
                  findet man auf{' '}
                  <a className='external' href='http://www.autoumweltliste.ch'>
                    autoumweltliste.ch
                  </a>
                  .
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Kreuzfahrten' impact='❋❋❋'>
                  Unterschätztes Thema. Die meisten Kreuzfahrtschiffe sind
                  Dreckschleudern: Sie fahren mit Schweröl und haben keine
                  Abgasreinigung. Ein einziges Schiff pustet so viel Russ und
                  Schwefel in die Luft wie Hunderttausende Autos – und das oft
                  in sensiblen Küstengebieten. Auch die Klimabilanz ist nicht
                  gut. Informieren Sie sich genau über Ihr Schiff, bevor Sie
                  eine Reise buchen:{' '}
                  <a
                    className='external'
                    href='https://www.nabu.de/umwelt-und-ressourcen/verkehr/schifffahrt/kreuzschifffahrt/'
                  >
                    nabu.de
                  </a>
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Motor' impact='❋❋❋'>
                  Grundsätzlich: Der Motortyp ist beim Auto nicht das
                  Entscheidende. Wichtiger ist erstens das Gewicht: Je schwerer
                  das Auto, desto höher der Energieverbrauch für Produktion und
                  Antrieb{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#autogroesse'>
                    [&rarr;Autogrösse]
                  </Scrollchor>
                  . Wichtiger ist zweitens die Herkunft der Energie. Wenn es mit
                  Kohlestrom fährt, produziert ein Elektroauto mehr Klimagase
                  als ein Verbrennungsmotor. Wird es mit Ökostrom betrieben, ist
                  der Betrieb zwar klimafreundlich, aber in der Batterie stecken
                  trotzdem viele, teils heikle Rohstoffe.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card' id='diesel'>
                <Tipp title='Diesel' impact='❋❋'>
                  Die deutsche Autoindustrie hat Abgaswerte frisiert und zu
                  Recht aufs Dach bekommen. Schade nur, dass dabei der Diesel
                  unter die Räder geraten ist. Denn er ist besser als sein Ruf.
                  Um das zu verstehen, muss man wissen, dass Abgase und
                  Klimagase nicht dasselbe sind. Abgase verpesten die Luft,
                  Klimagase heizen die Atmosphäre auf. Beim Autoantrieb sind die
                  beiden Gase leider Gegenspieler: Wer den Motor auf
                  Klimafreundlichkeit optimiert, bekommt dafür viele Abgase. Und
                  umgekehrt. Wenn nun die Autokäufer in Scharen vom Diesel zum
                  Benziner wechseln, ist das zwar gut für die Luft, aber
                  schlecht fürs Klima. Denn der Dieselmotor produziert weniger
                  Kohlendioxid als der Benzinmotor. Der Klimawandel ist aber
                  eindeutig das grössere der beiden Probleme – die Luft ist in
                  den letzten Jahren ohnehin schon deutlich sauberer geworden.
                  Wer also trotz gegenteiliger Empfehlung [?Motor] unbedingt ein
                  herkömmliches Auto will, soll einen Diesel zumindest in
                  Erwägung ziehen. Bitte auf die richtige Norm (Euro 6d-TEMP
                  oder Euro 6d) achten, dann ist auch das Abgasproblem
                  weitgehend vom Tisch. Für den reinen Stadtgebrauch ist der
                  Diesel sicher der falsche Antrieb, weil ohne regelmässige
                  Autobahnfahrten der Partikelfilter nicht richtig funktioniert.
                  Wer noch ein altes Dieselauto hat, für den gilt folgende
                  Faustregel: Mit Fahrzeugen der Norm Euro 6c oder älter bitte
                  möglichst selten in die Stadt fahren. Und mit Fahrzeugen ohne
                  Partikelfilter bitte möglichst gar nicht mehr fahren.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Fahrverhalten' impact='❋❋'>
                  Bremsen vernichtet Energie. Und erzeugt Feinstaub durch
                  Abrieb. Darum lautet der wichtigste Rat für ökologischeres
                  Chauffieren: Bremsmanöver vermeiden. Halten Sie Abstand,
                  fahren Sie vorausschauend, nehmen Sie den Schwung mit. Anders
                  formuliert: Fahren Sie mit dem Auto so wie mit dem Velo. Denn
                  Velofahrer, die für jeden Pedaltritt die Energie selber
                  aufbringen müssen, verhalten sich automatisch so, dass sie
                  möglichst selten bremsen müssen.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Geschäftsreisen' impact='❋❋'>
                  Sie sind das kleinere Problem. Die Zahl der Business-Flugtrips
                  pro Person stagniert, und die meisten Flugreisen sind ohnehin
                  privater Natur{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#fliegen'>
                    [&rarr;Fliegen]
                  </Scrollchor>
                  . Überdies können wir im Beruf weniger gut steuern, wie und
                  wie oft wir reisen. Trotzdem, ein wenig Einfluss hat jeder.
                  Argumentieren Sie nicht ethisch, das kommt womöglich nicht gut
                  an. Sagen Sie Ihrem Chef, Ihrer Chefin, dass es effizienter
                  sei, dieses oder jenes per Skype zu erledigen, statt sich in
                  den Flieger zu setzen. In Zukunft wird hier die erweiterte
                  Realität (Augmented Reality, AR) grosse Erleichterungen
                  bringen. Für Sitzungen und Konferenzen, deren Teilnehmer sich
                  an verschiedenen Orten befinden, gibt es schon heute
                  entsprechende Software. Und es ist absehbar, dass etwa
                  Servicemonteure, die heute bis zu 80 Prozent ihrer Zeit
                  unterwegs sind, in Zukunft mit aufgesetzter AR-Brille aus der
                  Ferne einem Mitarbeiter vor Ort Anweisungen geben, welche
                  Handgriffe er an einer Maschine vornehmen soll.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Kaltstart' impact='❋❋'>
                  Ein einziger Kaltstart mit einem Benzinauto erzeugt gleich
                  viele Schadstoffe wie 500 Kilometer Fahrt auf der Autobahn.
                  Dies liegt daran, dass der Katalysator erst funktioniert, wenn
                  er heiss ist. Faustregel: Wenn der Motor zehn Minuten
                  ausgeschaltet war, ist der Katalysator wieder kalt. Wer einen
                  Benziner hat, sollte darum gut planen: Lieber eine grössere
                  Fahrt statt viele kleine. Umparkieren vermeiden. Für
                  Kürzestfahrten das Velo nehmen. Und nein, es ist keine gute
                  Lösung, den Motor möglichst selten abzustellen. Denn er
                  verbraucht auch im Leerlauf Benzin. Bei Diesel-, Hybrid- und
                  Gasautos ist das Kaltstartproblem viel weniger ausgeprägt.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Klimaanlage' impact='❋❋'>
                  In vielen Autos ist die Klimaanlage standardmässig auf
                  «Automat» eingestellt. Was viele nicht wissen: Die Anlage
                  läuft dann auch bei kühlen Temperaturen. Ist etwa die
                  Aussenluft 15 Grad warm, so kühlt die Klimaanlage sie auf 5
                  Grad ab, um sie zu entfeuchten, heizt sie dann wieder auf 20
                  Grad auf und pustet sie ins Autoinnere. Das braucht viel
                  Energie. Darum schaltet man die Klimaanlage am besten ganz aus
                  – jedenfalls solange es im Auto nicht wärmer als 25 Grad ist
                  und die Scheiben nicht beschlagen.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Treibstoffverbrauch' impact='❋❋'>
                  Der Benzin- und Dieselverbrauch liegt bei den meisten Autos in
                  der Praxis 20 bis 50 Prozent höher als ausgewiesen. Grund
                  dafür ist der realitätsferne Test, mit dem der Verbrauch bis
                  anhin gemessen wurde. Mittlerweile gibt es einen realistischen
                  Test namens WLTP, doch solange sie es noch dürfen, geben die
                  meisten Autoverkäufer lieber die alten, falschen Zahlen an.
                  Fragen Sie Ihren Händler darum unbedingt nach den neuen
                  WLTP-Zahlen, oder schlagen Sie diese hier nach:{' '}
                  <a
                    className='external'
                    href='https://www.srf.ch/sendungen/content/download/16577137/file/fahrzeugtabelle_bereinigt_neu.pdf'
                  >
                    srf.ch
                  </a>
                  .
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card' id='car'>
                <Tipp title='Car' impact='❋'>
                  Gewiss: Die Eisenbahn ist ökologisch meilenweit besser als das
                  Auto oder das Flugzeug. Dennoch ist sie nicht immer erste
                  Wahl. Wer in der Schweiz oder in Frankreich Ferien macht, wo
                  der Strom CO<sub>2</sub>-arm produziert wird, nimmt
                  tatsächlich am besten den Zug. Für Reisen nach Deutschland
                  oder Polen hingegen, wo viele Strecken nicht elektrifiziert
                  sind und der Strom teilweise aus Kohlekraftwerken kommt, haben
                  Fernbus und Car eine leicht bessere Klimabilanz.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Elektrovelo' impact='❋'>
                  Das Elektrovelo ist nicht so gut wie sein Ruf: Pro gefahrenen
                  Kilometer belastet es die Umwelt mehr als ein
                  Eisenbahnpassagier. Wegen des Booms der Elektrovelos werden
                  auch weniger normale Velos verkauft, was für die Umwelt ein
                  Minusgeschäft ist. Faustregel: Wo es das Auto, den Töff, das
                  Töffli oder auch den Bus ersetzt, ist das Elektrovelo gut.
                  Doch solange man fit genug ist, bleibt man besser beim
                  Tretvelo.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Kompensieren' impact='❋'>
                  Klar, ein Flug mit Kompensation ist besser als ein Flug ohne
                  Kompensation. Immerhin wird mit dem Geld zum Beispiel ein Wald
                  in Nicaragua aufgeforstet, der dann der Atmosphäre das CO
                  <sub>2</sub>
                  wieder entzieht, das wir hinausgeblasen haben. Trotzdem, in
                  ihrer Gesamtwirkung ist die Möglichkeit zur Kompensation
                  zumindest zweifelhaft. Denn erstens entsteht dadurch der
                  Eindruck, das Problem sei mit Geld lösbar. Zweitens besteht
                  die Gefahr eines{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#rebound-effekt'>
                    &rarr;Rebound-Effekts
                  </Scrollchor>
                  . Nach dem Motto: Ich habe mich freigekauft, also kann ich
                  umso hemmungsloser drauflosfliegen.
                </Tipp>
              </div>
            </div>
          </div>
        </div>

        <figure className={'ui vertical padded segment'}>
          <img
            src={wohnen.sources['1280w']}
            srcSet={wohnen.srcSet}
            sizes={'100vw'}
            alt='Ist ja sehr hübsch, aber ist es auch wirklich nötig? Wenn wir nicht öfter mal das Licht ausmachen, sieht es für uns düster aus.'
            className='ui fluid image'
          />
          <figcaption className='ui container'>
            Ist ja sehr hübsch, aber ist es auch wirklich nötig? Wenn wir nicht
            öfter mal das{' '}
            <Scrollchor animate={{ offset: -10 }} to='#licht'>
              &rarr;Licht
            </Scrollchor>{' '}
            ausmachen, sieht es für uns düster aus. (Bild: Sally Anscombe/Getty
            Images)
          </figcaption>
        </figure>

        <Waypoint scrollableAncestor={window} onEnter={(event) => {
          if (event.previousPosition === Waypoint.below) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              'event': '30ContentRead'
            }
            )
          }
        }} />

        <div className='ui tipps container' id='wohnen'>
          <h2>Wohnen</h2>
          <div className='ui three column doubling stackable masonry grid'>

            <div className='column'>
              <div className='ui fluid card' id='bauen'>
                <Tipp title='Bauen' impact='❋❋❋❋❋'>
                  In der Schweiz wird gebaut wie wild. Aus einem wirklich doofen
                  Grund: weil die Zinsen so niedrig sind. Das treibt nicht nur
                  die Zersiedelung voran, sondern auch den Klimawandel. Die
                  Emissionen der Bauindustrie sind ein vernachlässigtes Thema: 7
                  Prozent des globalen CO<sub>2</sub>-Ausstosses stammen aus der
                  Zementherstellung, nochmals 9 Prozent aus der Stahl- und
                  Eisenproduktion. Und da ist der Diesel für die Baumaschinen
                  noch nicht eingerechnet. Bevor Sie also dazu ansetzen, ein
                  Haus zu bauen, überlegen Sie bitte: Muss es wirklich sein?
                  Können Sie nicht einen der vielen leer stehenden Neubauten
                  kaufen? Oder ein altes Haus sanft renovieren? Wenn es wirklich
                  sein muss: Durch eine geschickte Wahl der Materialien und der
                  Konstruktion lässt sich extrem viel graue Energie sparen.
                  Bauen Sie leicht und kompakt, erwägen Sie die Nutzung von
                  recyceltem Material, und achten Sie auf die
                  Wiederverwertbarkeit Ihres Baus. Verlangen Sie, wenn Sie
                  Offerten einholen, eine Berechnung des gesamten CO<sub>2</sub>
                  -Verbrauchs, einschliesslich der Materialproduktion. Oder
                  bauen Sie am besten gleich nach einem zertifizierten Standard.
                  Minergie-Eco minimiert sowohl die Klimawirkung des Baus als
                  auch den Energieverbrauch des Hauses im Betrieb:
                  <a
                    className='external'
                    href='http://www.minergie.ch/de/zertifizieren/eco'
                  >
                    minergie.ch
                  </a>
                  . Wenn Sie genug langfristig denken, lohnt sich das auch von
                  den Kosten her.
                </Tipp>
              </div>
            </div>


            <div className='column'>
              <div className='ui fluid card' id='heizen'>
                <Tipp title='Heizen' impact='❋❋❋❋❋'>
                  Riesenfaktor. 70 Prozent des direkten Energieverbrauchs der
                  Schweizer Privathaushalte gehen aufs Konto des Heizens. Jedes
                  bisschen, das Sie hier einsparen können, zahlt sich aus. Es
                  reicht, ein wenig am Regler zu drehen: Eine um 1 Grad tiefere
                  Raumtemperatur bedeutet 6 Prozent weniger Energieverbrauch.
                  Nein, es ist kein Menschenrecht, im Winter im T-Shirt auf dem
                  Sofa sitzen zu können. 20 Grad sind eine vernünftige
                  Temperatur für die Stube, vielleicht 21 im Bad. In der Küche
                  genügen 18 Grad, im Schlafzimmer 17 und eine Bettmütze. Ziehen
                  Sie das Pyjama im Badezimmer an, wenn es Ihnen im Schlafzimmer
                  dafür zu kalt ist. Verwenden Sie Zeitschaltuhren oder smarte
                  Apps, um die Raumtemperatur in der Nacht und in den Ferien
                  anzupassen – allenfalls auch tagsüber, wenn niemand zu Hause
                  ist. Schliessen Sie nachts die Fensterläden. Bitte im Winter
                  keine Fenster gekippt halten, stattdessen stosslüften. Was den
                  richtigen Heizungstyp betrifft, so sind heute Wärmepumpen das
                  Mittel der Wahl. Im Vergleich zu einer Ölheizung lassen sich
                  damit gegen 90 Prozent CO<sub>2</sub> einsparen. Richtig
                  gerechnet, das heisst auf die ganze Lebensdauer, sind sie auch
                  nicht teurer. Ausserdem sparen sie Platz, es braucht ja keinen
                  Tank. Am effizientesten sind Erd- oder Wasser-Wärmepumpen –
                  dafür sind Luft-Wärmepumpen günstiger bei der Installation.
                  Wenn es sich nicht um einen Notfall handelt, das heisst wenn
                  Ihre alte Heizung noch funktioniert, so ist es vernünftiger,
                  vor dem Ersatz zuerst das Haus richtig zu{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#isolieren'>
                    &rarr;Isolieren
                  </Scrollchor>
                  . Sie werden danach nur noch eine kleine Heizung benötigen. In
                  der Stadt ist die Fernwärme eine ökologisch vertretbare
                  Alternative zur Wärmepumpe, auf dem Land der{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#holzoefen'>
                    &rarr;Holzofen
                  </Scrollchor>
                  .
                </Tipp>
              </div>
            </div>


            <div className='column'>
              <div className='ui fluid card' id='isolieren'>
                <Tipp title='Isolieren' impact='❋❋❋❋❋'>
                  Mit einer Dachisolation, Fassadendämmung und neuen Fenstern
                  lassen sich bis zu 70 Prozent der Heizenergie einsparen. Bevor
                  Sie handeln: Nehmen Sie sich Zeit, studieren Sie verschiedene
                  Varianten, erstellen Sie ein Gesamtkonzept. Am besten, Sie
                  kontaktieren einen qualifizierten Energieberater aus Ihrer
                  Region. Den finden Sie unter{' '}
                  <a className='external' href='http://www.energieschweiz.ch'>
                    energieschweiz.ch
                  </a>
                  .
                </Tipp>
              </div>
            </div>


            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Wohnfläche' impact='❋❋❋❋❋'>
                  Die Kinder sind ausgezogen, der Partner ist gestorben: Von
                  einem gewissen Alter an leben viele Menschen in einem viel zu
                  grossen Haus. Ziehen Sie in eine kleine Wohnung! Mit der
                  Reduktion der Wohnfläche um ein Drittel sparen Sie etwa 15
                  Prozent Ihres CO<sub>2</sub>-Verbrauchs ein.
                </Tipp>
              </div>
            </div>


            <div className='column'>
              <div className='ui fluid card' id='duschen'>
                <Tipp title='Duschen' impact='❋❋❋❋'>
                  Alles, was mit Wärme zu tun hat, frisst viel Energie. In
                  Schweizer Haushalten gehen 13 Prozent der Energie für das
                  Warmwasser drauf – da lohnt es sich zu sparen. Duschen Sie
                  kurz und nicht zu heiss, montieren Sie eine Sparbrause, das
                  halbiert den Energieverbrauch. Unbedingt abzuraten, sowohl
                  ökologisch als auch dermatologisch, ist von der offenbar
                  zunehmenden Tendenz, zweimal täglich zu duschen. Selbst die
                  tägliche Dusche ist keineswegs obligat, wenn man nicht gerade
                  in einer Kohlenmine arbeitet. Probieren Sie in den Ferien aus,
                  wie lange es ohne geht. Trotz allem ist eine Dusche immer noch
                  viel besser als ein Vollbad, es sei denn, Sie tunken eine
                  vierköpfige Kinderschar ins gleiche Badewasser. Ein Bad lässt
                  man sich ja meist nicht aus hygienischen Gründen ein, sondern
                  aus einem Bedürfnis nach Wärme und Wohligkeit. Aber vielleicht
                  liesse sich dieses auch energiesparend mit einer Bettflasche
                  und einer flauschigen Decke befriedigen?
                </Tipp>
              </div>
            </div>


            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Gärten' impact='❋❋❋❋'>
                  Sind für die Artenvielfalt unheimlich wichtig. Eine
                  Untersuchung in Basel hat jüngst gezeigt: Selbst in isolierten
                  Kleinstgärten leben erstaunlich viele Insekten. Die Vielfalt
                  ist dabei umso grösser, je abwechslungsreicher der Garten ist.
                  Bäume, Büsche, hohes und niedriges Gras, Steinmauern und
                  Kiesflächen, Ast-, Laub- und Komposthaufen: Jedes Element ist
                  ein Lebensraum für zusätzliche Arten. Vielfalt schafft
                  Vielfalt! Bitte keinen Kirschlorbeer, Thuja und ähnliche
                  Importgewächse setzen, denn unsere Vögel und Insekten stehen
                  auf einheimisches Futter. Merkblätter und Tipps gibts unter{' '}
                  <a
                    className='external'
                    href='http://www.birdlife.ch/de/content/siedlungsraum'
                  >
                    birdlife.ch
                  </a>
                  .
                </Tipp>
              </div>
            </div>


            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Bäume' impact='❋❋❋'>
                  Der Neubesitzer einer Liegenschaft legt als Erstes gern mal
                  alle Bäume im Garten um. Sind ja schliesslich nicht seine.
                  Bitte folgen Sie diesem Reflex nicht! Ein alter Baum ist viel
                  mehr als ein Baum, er ist ein ganzes Ökosystem: Heerscharen
                  von Vögeln und Insekten, Flechten und Pilzen leben davon.
                  Nicht zuletzt speichert ein grosser Baum auch eine grosse
                  Menge Kohlendioxid – das Fällen einer hundertjährigen Buche
                  ist fürs Klima gleich schlimm wie ein Retourflug nach Tokio.
                  Umgekehrt ist das Pflanzen eines Baumes die einfachste und
                  billigste Massnahme, der Atmosphäre CO<sub>2</sub> zu
                  entziehen.
                </Tipp>
              </div>
            </div>


            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Gift' impact='❋❋❋'>
                  Verzichten Sie rund ums Haus und im Garten auf Gift. Es trägt
                  zum Insektensterben bei, und viele Privatanwender dosieren es
                  viel zu hoch. Übrigens: Auf versiegelten Flächen, etwa auf dem
                  Sitzplatz und auf Wegen, ist die Anwendung von Herbiziden
                  verboten – mit dem Regen landet das Zeug nämlich im nächsten
                  Bach oder im Grundwasser. Für Alternativen zum Gift:{' '}
                  <a className='external' href='http://www.giftzwerg.ch'>
                    giftzwerg.ch
                  </a>
                </Tipp>
              </div>
            </div>


            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Rasen' impact='❋❋❋'>
                  Die klassische Rasenfläche ist etwa so lebendig wie die nähere
                  Umgebung des Südpols. Hand aufs Herz: Finden Sie diese grüne
                  Einöde wirklich attraktiv? Verwandeln Sie einen Teil des
                  Rasens in ein Blütenmeer. Eine Blumenwiese lässt sich ziemlich
                  leicht anlegen und gibt erst noch wenig zu tun – man sollte
                  sie höchstens zweimal jährlich mähen. Lassen Sie sich dabei
                  Zeit: Verschiebt man den ersten Schnitt vom 15. Juni auf den
                  15. Juli, so verfünffachen sich etwa die Populationen von
                  Heuschrecken und nützlichen Schlupfwespen in der Wiese.
                  Merkblätter zum Anlegen von Blumenwiesen und anderen
                  Ökoflächen gibts hier:{' '}
                  <a
                    className='external'
                    href='https://www.stadt-zuerich.ch/ted/de/index/gsz/angebote_u_beratung/publikationen/PublikationenBiodiversitaet.html'
                  >
                    stadt-zuerich.ch
                  </a>
                </Tipp>
              </div>
            </div>


            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Torf' impact='❋❋❋'>
                  Torfböden sind der grösste natürliche Kohlenstoffspeicher der
                  Welt. Sie entziehen der Atmosphäre jährlich mehr Kohlendioxid
                  als alle Wälder zusammen. Doch wenn man Torf abbaut oder Moore
                  entwässert, entweichen die Klimagase wieder in die Luft. Fast
                  6 Prozent der menschlichen CO<sub>2</sub>-Emissionen stammen
                  aus dieser Quelle. Darum sollten wir schleunigst damit
                  aufhören, Torf zu verbrauchen. Immerhin sind die wenigen
                  verbliebenen Schweizer Moore seit der Rothenthurm-Initiative
                  geschützt. Aber der Torf, den Hobbygärtner immer noch in rauen
                  Mengen verbuddeln, wird nun einfach importiert. Verzichten
                  Siedarauf! Es gibt genügend Ersatzprodukte, die dem Torf
                  zumindest ebenbürtig sind. Auf das Kleingedruckte achten: Auch
                  sogenannte Bioerde kann Torf enthalten.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Waschen' impact='❋❋❋'>
                  Da lässt sich viel rausholen. Für normal verschmutzte Wäsche
                  reichen 30 Grad – braucht zwei Drittel weniger Strom als 60
                  Grad. Konsequent mit dem Energiesparprogramm waschen und hohe
                  Schleuderzahlen vermeiden. Auf den Tumbler verzichten, der ist
                  ein Energiefresser. Selbst bei Minustemperaturen kann man die
                  Wäsche draussen aufhängen, es braucht nur Geduld. Vorsicht,
                  die Kleider können brechen, wenn sie steif gefroren sind.
                  Sobald sie wirklich trocken sind, werden sie wieder weich.
                </Tipp>
              </div>
            </div>


            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Haustiere' impact='❋❋'>
                  Sie bereiten viel Freude – brauchen aber auch Energie.
                  Haustiere fressen, beanspruchen Lebensraum, müssen zum
                  Tierarzt. Je grösser sie sind, desto höher die
                  Umweltbelastung: Die jährlichen Umweltkosten eines Pferdes
                  entsprechen einer Autofahrt von 23 000 Kilometern. Die
                  Belastung steigt, wenn man oft an Turniere reist, und sinkt,
                  wenn man einheimische Hobelspäne statt Stroh als Einstreu
                  verwendet. Ein durchschnittlicher Hund entspricht noch einer
                  Autofahrt von 4000 Kilometern jährlich, wobei es entscheidend
                  darauf ankommt, ihm keine Entrecôtes in den Fressnapf zu
                  legen, sondern normales Hundefutter, das vorwiegend aus
                  Schlachtabfällen besteht. Bitte in Wäldern und
                  Naturschutzgebieten Hunde an die Leine nehmen{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#outdoor'>
                    [&rarr;Outdoor]
                  </Scrollchor>
                  . Eine einzelne Katze hat eine geringe Umweltbelastung –
                  allerdings gibt es von ihnen so viele, dass ihre
                  Gesamtpopulation doch wieder eine beträchtliche Wirkung hat.
                  Katzen sind Raubtiere und erbeuten auch seltene Vögel und
                  Reptilien. Am Waldrand oder in der Nähe von Schutzgebieten und
                  Naturgärten darum möglichst keine Freigängerkatzen halten.
                </Tipp>
              </div>
            </div>



            <div className='column'>
              <div className='ui fluid card' id='holzoefen'>
                <Tipp title='Holzöfen' impact='❋❋'>
                  Sind gut fürs Klima, aber schlecht für die Luft. Der Boom der
                  Holzfeuerungen trägt zu einem nicht unbedeutenden Teil zur
                  zunehmenden Feinstaubbelastung bei. Mit ein paar Tricks kann
                  man die Verbrennung sauberer machen: nur gut getrocknetes Holz
                  nehmen, kein Zeitungspapier zum Anzünden verwenden, vor dem
                  Ins-Bett-Gehen die Luftzufuhr nicht kappen. Doch selbst aus
                  dem besten Holzfeuer entweicht noch immer ziemlich viel
                  Feinstaub. Darum sollte man Holzöfen nicht in dicht
                  besiedelten Gebieten betreiben. Ideal sind sie in den Bergen,
                  wo sich die Luft gut durchmischt und Wärmepumpen [?Heizen]
                  nicht so effizient laufen. Darauf achten, dass das Holz aus
                  nahe gelegenen, nachwachsenden Wäldern kommt. Auf reine
                  Wohlfühlkamine am besten ganz verzichten.
                </Tipp>
              </div>
            </div>



            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Kochen' impact='❋❋'>
                  Öfter einmal kalt essen. Grosse Portionen kochen, die für zwei
                  oder drei Mahlzeiten ausreichen. Zum Aufwärmen die Mikrowelle
                  benutzen. Den Backofen nur sparsam einsetzen, nicht vorheizen,
                  den Umluftmodus mit einer geringeren Backtemperatur wählen.
                  Und egal, ob man von Hand oder per Maschine abwäscht: auf
                  warmes Vorspülen verzichten.
                </Tipp>
              </div>
            </div>


            <div className='column'>
              <div className='ui fluid card' id='licht'>
                <Tipp title='Licht' impact='❋❋'>
                  Setzen Sie LED-Birnen ein: Sie halten länger und verbrauchen
                  nur einen Bruchteil der Energie anderer Lampentypen. Vorsicht
                  vor dem{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#rebound-effekt'>
                    &rarr;Rebound-Effekt
                  </Scrollchor>
                  . Für nächtliche Gänge oder auch beim Zähneputzen reicht ein
                  Solarlicht, siehe etwa{' '}
                  <a className='external' href='http://www.sonnenglas.net'>
                    sonnenglas.net
                  </a>
                  , so schlafen Sie nachher auch leichter ein. Solarlampen kann
                  man auch im Garten verwenden, wobei – eigentlich braucht es
                  draussen ja keine Dauerlichter. Die Lichtverschmutzung hat in
                  den letzten Jahren extrem zugenommen und bedeutet den Tod von
                  Millionen nachtaktiver Insekten. Verzichten Sie auf
                  Zierlämpchen, und setzen Sie draussen nur Lichter ein, die
                  Ihrer Sicherheit dienen. Richten Sie sie nach unten aus,
                  versehen Sie sie mit einem Bewegungsmelder, und verdecken Sie
                  möglichst den eigentlichen Leuchtkörper.
                </Tipp>
              </div>
            </div>


            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Tierfallen' impact='❋❋'>
                  Glasfronten, Swimmingpools, offene Schächte: Hier kommen
                  unzählige Tiere zu Tode. Legen Sie ein Gitter über Schächte
                  und Tonnen, bieten SieAusstiegshilfen aus Pools und
                  Kellerabgängen – etwa ein nicht zu steiles Brett. Entschärfen
                  Sie Glasscheiben mit hellen Vorhängen, gemusterter Folie,
                  dicht platzierten Aufklebern. Auf die Form kommt es nicht an,
                  wählen Sie ein Sujet, das Ihnen gefällt. Vorsicht: Es reicht
                  nicht, ein paar Greifvogel-Silhouetten anzubringen:Vögel
                  empfinden diese nicht als gefährlich, weil sie sich nicht
                  bewegen.{' '}
                  <a className='external' href='http://www.vogelglas.info'>
                    vogelglas.info
                  </a>
                  .
                </Tipp>
              </div>
            </div>


            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Balkon' impact='❋'>
                  Auch wer in einem Block wohnt, kann etwas für die Insekten
                  tun. In kleinerem Massstab lässt sich auf einem Balkon fast
                  alles pflanzen, was auch im Garten wächst. Sie sorgen sich um
                  die Bienen und haben darum ein Wildbienenhotel aufgestellt?
                  Gut so. Aber sehen Sie zu, dass die Tiere auch etwas zu
                  fressen haben. Taubenskabiose, Natternkopf, Esparsette,
                  Wundklee und Glockenblumen sind bei Bienen besonders beliebt.
                  Achten Sie darauf, dass möglichst von Frühling bis Herbst
                  etwas blüht – aber verzichten Sie auf Geranien und Petunien:
                  Sie sind ökologisch wertlos, denn man hat ihnen den Nektar
                  weggezüchtet, damit sie länger blühen.
                </Tipp>
              </div>
            </div>



            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Begrünen' impact='❋'>
                  Fassaden und Dächer lassen sich begrünen. Das schafft
                  Lebensraum und kühlt nebenbei gratis das Gebäude. Bringen Sie
                  Nisthilfen an. Denken Sieauch bei Renovationen daran, die
                  Fassade nicht zu Tode zu sanieren – Tiere brauchen
                  Schlupfwinkel. Es gibt heute Lösungen, die tierfreundlich
                  sind, ohne dadurch schlechter zu{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#isolieren'>
                    &rarr;Isolieren
                  </Scrollchor>
                  :{' '}
                  <a className='external' href='http://www.bauen-tiere.ch'>
                    bauen-tiere.ch
                  </a>
                  .
                </Tipp>
              </div>
            </div>


            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Kühlschrank' impact='❋'>
                  Der Kühlschrank ist meistens viel zu kalt eingestellt. Drehen
                  Sie ihn auf die wärmste oder zweitwärmste Stufe. Wenn Sie
                  jedoch ein Problem mit{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#foodwaste'>
                    &rarr;Foodwaste
                  </Scrollchor>{' '}
                  haben, lassen Sie den Kühlschrank besser kühl, so halten die
                  Speisen länger. Regelmässig enteisen, Türe stets nur kurz
                  öffnen. Tauen SieTiefgefrorenes im Kühlschrank auf, das senkt
                  den Energieverbrauch.
                </Tipp>
              </div>
            </div>

          </div>
        </div>

        <figure className={'ui vertical padded segment'}>
          <img
            src={konsum.sources['1280w']}
            srcSet={konsum.srcSet}
            sizes={'100vw'}
            alt='Kinder sind ein Quell des Glücks. Aus Sicht des Umweltschutzes sind sie Plagegeister. Natürlich nur aus Sicht des Umweltschutzes.'
            className='ui fluid image'
          />
          <figcaption className='ui container'>
            <Scrollchor animate={{ offset: -10 }} to='#kinder'>
              &rarr;Kinder
            </Scrollchor>{' '}
            sind ein Quell des Glücks. Aus Sicht des Umweltschutzes sind sie
            Plagegeister. Natürlich nur aus Sicht des Umweltschutzes. (Bild:
            Getty Images)
          </figcaption>
        </figure>

        <Waypoint scrollableAncestor={window} onEnter={(event) => {
          if (event.previousPosition === Waypoint.below) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              'event': '50ContentRead'
            }
            )
          }
        }} />

        <div className='ui tipps container' id='konsum'>
          <h2>Konsum & Freizeit</h2>
          <div className='ui three column doubling stackable masonry grid'>

            <div className='column'>
              <div className='ui fluid card' id='kinder'>
                <Tipp title='Kinder' impact='❋❋❋❋❋'>
                  Ein Tabuthema. Aber wir müssen es ansprechen, weil es so
                  unheimlich wichtig ist. Während die sogenannte Überbevölkerung
                  bis in die 1980er-Jahre noch als grosses Problem galt, scheint
                  man sich heute damit abgefunden zu haben, dass die Zahl der
                  Menschen wächst und wächst. Wer die simple Tatsache erwähnt,
                  dass das Ausmass der Umweltprobleme proportional zur
                  Bevölkerungszahl zunimmt, gilt schon fast als Provokateur. Als
                  eine schwedisch-kanadische Studie 2017 «ein Kind weniger» als
                  effektivste persönliche Massnahme zur Bekämpfung des
                  Klimawandels bezeichnete, ging ein Aufschrei um die Welt.
                  Natürlich, es ist eine hochprivate Frage. Wir wollen hier
                  niemandem dreinreden – oder jedenfalls nur ein bisschen. Wir
                  möchten, dass Sie die Umweltfrage wenigstens als ein Kriterium
                  zulassen, wenn sich die Frage «Noch eins mehr oder nicht?»
                  stellt. Es geht ja nicht nur darum, dass dieses Kind
                  unvermeidlich Ressourcen verbrauchen und Kohlendioxid
                  emittieren wird. Familienzuwachs ist häufig auch ein Grund, in
                  ein grosses Haus zu ziehen oder halt doch ein Auto
                  anzuschaffen, auch wenn man eigentlich nie eines wollte. Das
                  Mindeste, was Sie tun können: Ihre Kinder zu ökologisch
                  verantwortungsvollen Lebewesen erziehen.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Verzicht' impact='❋❋❋❋❋'>
                  Von grüner Seite, vor allem von Firmen, die auf der grünen
                  Welle mitsurfen, ist oft zu hören, die Umstellung auf einen
                  ökologischen Lebensstil bedeute gar keinen Verzicht. Das mag
                  gut tönen, stimmt aber nicht. Der Verzicht ist sogar der Kern
                  der Sache. Klar lassen sich die Bodylotion durch
                  Biokörpermilch ersetzen und der BMW durch einen E-Golf, das
                  bringt vielleicht auch ein bisschen etwas. Aber die Idee, wir
                  könnten mit dem richtigen Konsum die Welt retten, ist falsch:
                  Viele grüne Produkte, vom Biolachs über die Solarzelle bis zur
                  Holzzahnbürste, sind gar nicht mehr so grün, sobald sie
                  grossmassstäblich produziert werden. Bei allen entscheidenden
                  Punkten geht es letzten Endes immer um ein Weniger: weniger
                  Autos, weniger Fliegen, weniger Wohnraum, weniger Fleisch,
                  weniger Kleider – mit einem Wort: weniger Konsum. Dass dies
                  auch befreiend wirken, ja vielleicht sogar ein neues
                  Lebensgefühl initiieren kann: geschenkt. Ein Verzicht bleibt
                  es trotzdem.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Einkommen' impact='❋❋❋'>
                  Der Mensch empfindet sich als rationales, von Überzeugungen
                  geleitetes Wesen. In Wahrheit folgen wir oft genug Gesetzen,
                  von denen wir nicht einmal ahnen, dass sie existieren. So
                  lässt sich denn auch der «Green Gap» erklären: die
                  unübersehbare Diskrepanz zwischen grünem Denken und grünem
                  Handeln. Nichts illustriert diese deutlicher als eine Umfrage
                  in Deutschland vor ein paar Jahren, die ergab, dass
                  ausgerechnet die Anhängerinnen und Anhänger der Partei der
                  Grünen am meisten fliegen. Die Erklärung: Grünen-Wähler sind
                  reicher als der Durchschnitt, und Reiche fliegen häufiger.
                  Schlicht weil sie es sich leisten können. Dieses Gesetz ist
                  offenbar stärker als jede Gesinnung. Den Zusammenhang zwischen
                  Einkommen und Klimagas-Ausstoss findet man überall: In der
                  Schweiz fliegen Personen mit einem Haushaltseinkommen über 12
                  000 Franken fünfmal so viel wie Leute mit einem
                  Haushaltseinkommen unter 4000 Franken. Insgesamt verursachen
                  die bestverdienenden 10 Prozent der Schweizerinnen und
                  Schweizer fast doppelt so viele Treibhausgase wie die 10
                  Prozent der am schlechtesten verdienenden. Wenn man von diesem
                  Zusammenhang weiss, kann man aber auch etwas dagegen
                  unternehmen. Erwägen Sie zum Beispiel, einen Tag weniger pro
                  Woche zu arbeiten, wenn es von der Firma her möglich ist und
                  Sie es sich leisten können. So überlisten Sie sich selber zu
                  einem ökologischeren Verhalten: Sie werden 20 Prozent weniger
                  konsumieren als bisher – und gewinnen dabei auch noch
                  Lebenszeit.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Flicken' impact='❋❋❋'>
                  Wird noch zu wenig kultiviert. Lassen Sie Geräte auch dann
                  reparieren, wenn Ihnen der Händler sagt, das lohne sich nicht
                  mehr. Für die Umwelt lohnt es sich nämlich schon, bloss für
                  den Händler nicht. Flickläden, Smartphonedoktoren und
                  Schuhmacher sind höchst sinnvolle Institutionen. Ebenso
                  Repair-Cafés, wo sich pensionierte Berufsleute mit viel
                  Ehrgeiz und Fachwissen darum bemühen, kaputte Laptops und
                  Nähmaschinen wieder zum Laufen zu bringen:{' '}
                  <a className='external' href='http://www.repair-cafe.ch'>
                    repair-cafe.ch
                  </a>
                  .
                </Tipp>
              </div>
            </div>


            <div className='column'>
              <div className='ui fluid card' id='kleider'>
                <Tipp title='Kleider' impact='❋❋❋'>
                  Schweizerinnen und Schweizer halten den Weltrekord in
                  Selbsttäuschung: Wir glauben, wir würden lediglich 26 Prozent
                  unserer Kleider nie tragen – in Wahrheit sind es sogar 79
                  Prozent. Und trotzdem werden unsere Kleiderschränke immer
                  voller. Gewöhnen Sie sich daher an, bevor Sie ein neues Teil
                  kaufen, zu fragen: Wann ganz konkret werde ich das Stück
                  tragen? Wie viele ähnliche Kleider habe ich schon zu Hause?
                  Falls Sie zu Frustkäufen neigen, probieren Sie doch, auf etwas
                  Materialärmeres umzusteigen, zum Beispiel auf Pralinen. Denn
                  ökologische Kleider gibt es nicht. Kunstfasern brauchen viel
                  Energie, Baumwolle viel Wasser (der Aralsee ist aus diesem
                  Grund vertrocknet) und Spritzmittel (Bio ist hier die bessere
                  Wahl). Nutzen Sie Kleiderbörsen, Secondhandshops,
                  Tauschplattformen. Noch besser: Kultivieren Sie die
                  Kleiderleihe. Man muss ja nicht alles besitzen.{' '}
                  <a className='external' href='http://www.kleihd.ch'>
                    kleihd.ch
                  </a>
                </Tipp>
              </div>
            </div>


            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Lebensdauer' impact='❋❋❋'>
                  Das Smartphone ersetzen wir alle zwei Jahre – nicht weil es
                  kaputt wäre, sondern weil das neue ein paar Funktionen mehr
                  hat. Oder weil man es uns quasi nachwirft. Elektronische
                  Geräte, Kleider, Schuhe: Kaum etwas wird bis an sein
                  natürliches Lebensende genutzt. Auch beispielsweise Häuser
                  <Scrollchor animate={{ offset: -10 }} to='#bauen'>
                    [&rarr;Bauen]
                  </Scrollchor>{' '}
                  oder Autos werden vorzeitig ersetzt, gerne mit dem Hinweis,
                  das neue sei dann energieeffizienter. In einer
                  Gesamtbetrachtung geht das aber nur selten auf. Die
                  Herstellung eines Neuwagens erzeugt so viel CO<sub>2</sub> wie
                  drei Langstreckenflüge. Das neue Autos vermag dies während
                  seiner Lebenszeit durch seinen Minderausstoss nur in den
                  wenigsten Fällen zu kompensieren. Einzig wer einen{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#diesel'>
                    &rarr;Diesel
                  </Scrollchor>{' '}
                  ohne Partikelfilter hat, sollte einen vorzeitigen Ersatz
                  erwägen – wegen der gesundheitsgefährdenden Abgase.
                </Tipp>
              </div>
            </div>


            <div className='column'>
              <div className='ui fluid card' id='outdoor'>
                <Tipp title='Outdoor' impact='❋❋❋'>
                  Es gibt kaum mehr einen Winkel des Landes, der nicht von
                  Bewegungsmanikern in Beschlag genommen wird, mit immer
                  ausgefalleneren Sportarten. Wir warten ja diesbezüglich noch
                  auf das Snowdiving, Bachjoggen, Eisfallrodeln und die
                  Baumkronenrallye mit Gleitschirmen. Lassen Sie den Tieren ein
                  wenig Platz! Respektieren Sie Schutzgebiete und Wildruhezonen.
                  Bleiben Sie auf den Wegen – Rehe und Vögel wissen, wo diese
                  verlaufen, und halten Abstand. Wenn Sie plötzlich querfeldein
                  daherkommen, schrecken Sie sie auf. Machen Sie keinen Lärm,
                  nehmen Sie den Hund an die Leine, insbesondere von April bis
                  Juni. Und gehen Sie nachts nicht im Wald biken oder joggen.
                  Gestört durch die Menschen, haben viele Tiere ihre
                  Aktivitätsphase in die Nacht verlegt – gönnen Sie ihnen
                  wenigstens dann ihre Ruhe.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Recycling' impact='❋❋❋'>
                  Beim Recyceln sind wir Weltspitze – toll! Weiter so! Das
                  Trennen und Entsorgen kommt unserem Ordnungssinn entgegen: Es
                  ist erstaunlich, mit welchem Eifer sich die Leute dem neu
                  aufkommenden Plastikrecycling widmen (nebenbei: Mit Ausnahme
                  von PET ist die Wiederverwertung beim Plastik nicht viel
                  besser als das Verbrennen). Was dabei vergessen geht: Auch bei
                  der Abfallproduktion sind wir Weltspitze. Mit dem Recyceln und
                  der Kehrichtverbrennung haben wir das Abfallproblem auf
                  unserer Seite gelöst – mit dem ungedrosselten Konsum
                  vergrössern wir aber gleichzeitig die Umweltprobleme in den
                  Ländern, die unsere Güter herstellen. Drei Viertel der
                  Umweltbelastung unseres Konsums entstehen im Ausland.
                  Versuchen Sie darum, beim Weniger-Konsumieren genauso
                  ambitioniert zu sein wie bei der Mülltrennung.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Unordnung' impact='❋❋❋'>
                  Seien Sie faul! Wer nicht immerzu das Gefühl hat, etwas
                  unternehmen oder erleben zu müssen, der richtet weniger
                  Schaden an. Ein krasses Beispiel sind unsere Gärten: Die
                  meisten sind überbetreut. Lassen Sie das Laub im Herbst
                  liegen, oder rechen Sie es zu Haufen zusammen, räumen Sie
                  Totholz und Fallobst nicht weg, lassen Sie dürre Stängel
                  stehen. Hier überwintern Kleintiere, ziehen ihren Nachwuchs
                  auf, finden Futter. Was die Menschen als Unordnung empfinden,
                  bedeutet für die Tiere Lebensraum. In einer Bodenmulde sammelt
                  sich immer wieder Wasser? Bitte nicht einebnen! Die
                  Mehlschwalben werden es Ihnen danken: Sie brauchen Lehm,
                  Schlamm oder feuchte Erde für den Nestbau.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Geräte' impact='❋❋'>
                  Fernseher und Stereoanlage richtig ausschalten: Stand-by
                  frisst Strom. Am besten überall ausschaltbare
                  Mehrfachsteckdosen montieren. Handy und Laptop am Nachmittag
                  laden, dann ist die Chance grösser, dass der Strom aus
                  erneuerbaren Quellen kommt. Nach dem Laden das Kabel aus der
                  Steckdose ziehen. Möglichst Geräte der besten Energieklasse
                  kaufen – Orientierungshilfe geben{' '}
                  <a className='external' href='http://www.topten.ch'>
                    topten.ch
                  </a>{' '}
                  und{' '}
                  <a className='external' href='http://www.compareco.ch'>
                    compareco.ch
                  </a>
                  .
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Internet' impact='❋❋'>
                  Klar ist eine E-Mail ökologischer als ein Brief, ein
                  Onlinevideo besser als eine DVD. Das Problem: Weil es so
                  bequem ist, steigt der Energieverbrauch des Internets
                  beständig, und zwar massiv{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#rebound-effekt'>
                    [&rarr;Rebound-Effekt]
                  </Scrollchor>
                  . Jede Google-Suche, jedes gepostete Foto, jedes gestreamte
                  Filmchen hinterlässt einen Fussabdruck. Versenden Sie Links
                  statt grosser Dateien, nutzen Sie die Funktion «allen
                  antworten» sparsam, kündigen Sie ungelesene Newsletter.
                  Löschen Sie alte Mails bei Ihrem Provider und alte Dateien in
                  der Cloud. Deaktivieren Sie Apps, die im Hintergrund
                  mitlaufen. Je kleiner das Gerät, mit dem man ins Internet
                  geht, desto energieeffizienter. Smartphone ist besser als
                  Tablet ist besser als Laptop ist besser als PC. Verbinden Sie
                  sich, wann immer möglich, via WLAN, es braucht viel weniger
                  Strom als das Mobilfunknetz. Angenehmer Nebeneffekt: Der Akku
                  hält länger. Reduzieren Sie die Bildschirmhelligkeit, dimmen
                  Sie die Anzeige, nutzen Sie den Schlummermodus.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card' id='maenner'>
                <Tipp title='Männer' impact='❋❋'>
                  Rein ökologisch betrachtet, ist der Mann ein problematisches
                  Wesen. Männer recyceln weniger. Männer in Single-Haushalten
                  verbrauchen ein Viertel mehr Strom als Frauen in identischen
                  Wohnungen. Männer essen wesentlich mehr Fleisch als Frauen.
                  Gewiss, Frauen kaufen mehr{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#kleider'>
                    &rarr;Kleider
                  </Scrollchor>{' '}
                  und Kosmetik, aber das wiegt das männliche Missverhalten
                  niemals auf. Dagegen vorzugehen ist schwierig, denn hier sind
                  archaische Kräfte am Walten. Jedenfalls haben psychologische
                  Studien gezeigt, dass Männer das Gefühl haben, Umweltschutz
                  sei etwas Unmännliches. Uns bleibt hier nur, an die
                  technisch-kompetitive Seite zu appellieren, die ja auch vielen
                  Männern innewohnt: Installieren Sie Gadgets, übernehmen Sie
                  die Kontrolle über den Energiefluss in Ihrem Haus{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#messen'>
                    [&rarr;Messen]
                  </Scrollchor>
                  . SeienSie ehrgeizig, auch im Umweltbereich. Suchen Sie nach
                  dem sparsamsten Kühlschrank, nach dem effizientesten Reiseweg.
                  Lassen Sie nicht zu, dass Ihr Nachbar eine bessere Ökobilanz
                  hat als Sie. Mit einem Wort: Seien Sie ein Mann!
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Onlineshopping' impact='❋❋'>
                  In einer idealen Welt wäre Onlineshopping genial: Über ein
                  ausgeklügeltes Verteilnetz würden alle Waren hocheffizient zu
                  den Haushalten gebracht – was viel ökologischer ist, als wenn
                  jeder seine zwei Liter Milch persönlich mit dem SUV abholt.
                  Leider, leider, ist die Welt nicht ideal, und darum sieht
                  Onlineshopping in der Praxis oft eher so aus: Fünf Paar Schuhe
                  bestellt, vier Paar wieder zurückgeschickt. Ist ja gratis und
                  so bequem. Dass das weder effizient noch nachhaltig ist,
                  dürfte selbst den sogenannten Heavy Shoppern einleuchten.
                  Übrigens: Nicht selten werden Retouren einfach vernichtet,
                  weil es sich nicht lohnt, sie zu prüfen und neu zu verpacken.
                  Hier ein paar Regeln zum guten Umgang mit Onlineshopping:
                  Rücksendungen minimieren. Besser keine Hosen oder Schuhe
                  online kaufen, die muss man anprobieren. Einkäufe bündeln, und
                  zwar bei möglichst wenig Anbietern. Auf Expresslieferungen und
                  Same Day Delivery verzichten, denn dafür fährt der Lastwagen
                  oftmals extra.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card' id='wasser'>
                <Tipp title='Wasser' impact='❋❋'>
                  Hier gibt es viele Missverständnisse. Zunächst einmal: Wasser
                  kann nicht «verbraucht» werden, denn es befindet sich in einem
                  endlosen Kreislauf. Mit Ausnahme des energiefressenden
                  Warmwassers{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#duschen'>
                    [&rarr;Duschen]
                  </Scrollchor>{' '}
                  hat es darum auch keinen Sinn, Wasser zu sparen, es sei denn,
                  es herrscht wirklich Knappheit, was in der Schweiz lokal in
                  Hitzesommern der Fall sein kann. Aus dem gleichen Grund ist es
                  auch unlogisch zu sagen, für ein Kilo Rindfleisch würden 15
                  000 Liter Wasser «verbraucht», wie es oft heisst. Denn dieses
                  Wasser besteht im Wesentlichen aus dem Regen, den es braucht,
                  damit das Gras wächst, das die Kuh frisst. Der Regen fällt
                  aber auch dann, wenn die Weide kuhfrei ist. Von einem
                  Wasserverbrauch zu sprechen, ist nur dann hilfreich, wenn
                  künstliche Bewässerung im Spiel ist. Problematisch ist die
                  intensive Gemüse- und Obstproduktion in sehr trockenen
                  Gebieten, etwa in Andalusien, wo es angeblich eine Million
                  illegaler Brunnen gibt, um die riesigen Plantagen zu
                  bewässern, damit wir jahrein, jahraus frische Tomaten und
                  Erdbeeren haben{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#regional'>
                    [&rarr;Regional]
                  </Scrollchor>
                  . Ein Wasserproblem gibts etwa auch wegen der Modefrucht
                  Avocado in Südamerika oder mancherorts wegen des
                  Baumwollanbaus{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#kleider'>
                    [&rarr;Kleider]
                  </Scrollchor>
                  .
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Bio' impact='❋'>
                  Hier begeben wir uns auf ein ideologisches Minenfeld. Bio ist
                  zweifellos sympathisch: Man giftet nicht, ist lieb zu den
                  Tieren, düngt weniger. Würden alle Schweizer Bauern auf Bio
                  umstellen, wäre das ein Segen für unser Land – wir hätten eine
                  höhere Artenvielfalt auf den Feldern und weniger Gift und
                  Gülle in den Gewässern. Nur: Weil die Erträge im biologischen
                  Landbau kleiner sind als im konventionellen, müssten wir dann
                  mehr Lebensmittel importieren. Für jeden Bauern, der auf Bio
                  umstellt, muss ein anderer irgendwo auf der Welt die
                  Anbaufläche ausdehnen. Das reduziert den Naturraum und
                  steigert den CO<sub>2</sub>-Ausstoss. Der Super-GAU ist dann
                  erreicht, wenn Moore entwässert oder Wälder gerodet werden, um
                  die Landwirtschaftsfläche zu vergrössern. Es gibt also zwei
                  Betrachtungen: Pro Hektar gerechnet, ist die biologische
                  Landwirtschaft besser als die konventionelle. Pro Kilo
                  Endprodukt aber ist Bio gesamtökologisch nur gleichwertig, in
                  Sachen Klima sogar eher schlechter als konventionell. Um aus
                  diesem Dilemma herauszukommen, gibt es nur eine Lösung: Massiv
                  weniger{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#fleisch'>
                    &rarr;Fleisch
                  </Scrollchor>{' '}
                  und weniger Milchprodukte essen. Dann sinkt der Flächenbedarf
                  der Landwirtschaft, und es hat Platz für nachhaltige
                  Anbauformen.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Bioplastik' impact='❋'>
                  Gibt es nicht. Was als Bioplastik verkauft wird, mag aus
                  organischen Materialien hergestellt sein, aber in einer
                  Gesamtbetrachtung ist es nicht ökologischer als Kunststoff.
                  Auch verrottet es nur zäh, weshalb Umweltorganisationen und
                  Verwertungszentren von sich angeblich selbst zersetzenden
                  Kompostsäckli abraten.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Bücher' impact='❋'>
                  Für Vielleser lohnt sich die Anschaffung eines E-Readers, denn
                  dieser verbraucht sehr wenig Energie. Schon beim zehnten Buch,
                  das man deswegen nicht auf Papier liest, kippt die Bilanz ins
                  Positive. Wenn Sie doch lieber analog lesen: Verschenken Sie
                  die Bücher nach Gebrauch. Oder nutzen Sie eine Bibliothek.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Kryptowährungen' impact='❋'>
                  Mag sein, dass ihnen die Zukunft gehört. Doch so, wie sie
                  heute funktionieren, sind sie ökologischer Blödsinn. Denn die
                  Technik dahinter verbraucht Unmengen von Energie, wobei es
                  sich typischerweise um chinesischen Kohlestrom handelt. Allein
                  Bitcoin verbraucht so viel Strom wie die ganze Schweiz.
                  Solange niemand eine schlauere Technologie entwickelt hat: die
                  Finger davon lassen.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Mikroplastik' impact='❋'>
                  Gehört zu den wenigen Umweltproblemen, die vermutlich
                  überschätzt werden. Nach heutigem Wissensstand ist
                  Mikroplastik in den gegenwärtigen Konzentrationen im Salz-wie
                  im Süsswasser nicht gefährlich für die Tiere. Kommt dazu, dass
                  bei uns Kläranlagen fast das ganze Mikroplastik aus dem Wasser
                  fischen. Das Bemühen, Mikroplastik aus unseren Produkten zu
                  verbannen, ist schon richtig. Aber Alarmismus ist nicht
                  angebracht.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Naturbad' impact='❋'>
                  Bei grosser Hitze und Trockenheit nicht in kleinen Bächen und
                  Tümpeln baden. Dies gilt insbesondere für Hunde. Die Fische
                  sind bei hohen Temperaturen und Niedrigwasser ohnehin schon am
                  Anschlag und vertragen keinen zusätzlichen Stress. Auch wer
                  sich mit Insektenspray eingesprüht hat, sollte nicht ins
                  Wasser: Die Mittel sind tödlich für manche Amphibien.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Plastik' impact='❋'>
                  In der Öffentlichkeit hat Plastik in den letzten Jahren das
                  Robbenbaby als Umweltthema Nummer eins abgelöst. Wem ginge der
                  Anblick eines Albatros nicht zu Herzen, der an verschlucktem
                  Plastik verreckt ist? Am nächsten Tag reissen wir die
                  Kunststofffolie von den Bio-Rüebli und fühlen uns schuldig.
                  Das Problem ist: Das eine hat mit dem anderen nichts zu tun.
                  Natürlich kann auch Ihre Plastikfolie ins Meer gelangen, wenn
                  Sie sie in die Aare schmeissen – aber das tun Sie ja nicht,
                  oder? 86 Prozent des Plastiks, das via Flüsse in die Ozeane
                  gelangt, stammen aus Asien. Aus Europa kommen gerade mal 0,3
                  Prozent. Überdies sind für das Ökosystem Meer andere, weniger
                  sichtbare Probleme vermutlich schlimmer als Plastik:
                  Sauerstoffmangel, Wassererwärmung, Versauerung, Überfischung.
                  Wenn Sie wirklich persönlich etwas für die Meere tun wollen,
                  dann hören Sie auf,{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#fisch'>
                    &rarr;Fisch
                  </Scrollchor>{' '}
                  zu essen.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Verpackungen' impact='❋'>
                  Die epische Diskussion um überflüssige Verpackungen verstellt
                  den Blick auf das Wesentliche. Das Wesentliche ist der Inhalt,
                  nicht die Hülle. Das Problem am Kaffee ist nicht der Becher,
                  das Problem am Smartphone nicht die überdimensionierte
                  Schachtel, das Problem am Einkauf nicht der Plastiksack von
                  der Kasse. Das Problem ist vielmehr die Umweltbelastung durch
                  die Produktion der Waren. Im Vergleich dazu ist die Verpackung
                  meistens vernachlässigbar (Ausnahme:
                  <Scrollchor animate={{ offset: -10 }} to='#mineralwasser'>
                    &rarr;Mineralwasser
                  </Scrollchor>
                  ). Wer es trotzdem genauer wissen will: Leichte Verpackungen
                  sind meistens besser als schwere – darum muss man den
                  Baumwollsack für viele Dutzend Einkäufe benutzen, bis er
                  ökologisch mit den dünnen Plastiksäckchen gleichzieht.
                  Wiederverwertbare Materialien sind besser, also lieber
                  Mehrweg-statt Einwegflaschen. Die beste Verpackung ist gar
                  keine: Zero-Waste-Läden, mit dem Korb auf den Markt.
                  Allerdings halten unverpackte Waren weniger lang, es droht{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#foodwaste'>
                    &rarr;Foodwaste
                  </Scrollchor>
                  .
                </Tipp>
              </div>
            </div>

          </div>
        </div>

        <figure className={'ui vertical padded segment'}>
          <img
            src={ernaehrung.sources['1280w']}
            srcSet={ernaehrung.srcSet}
            sizes={'100vw'}
            alt='Nicht nur Glace: Jeder von uns wirft jede Woche zwei Kilogramm Essen weg. Dabei ist es sehr einfach, Foodwaste zu vermeiden.'
            className='ui fluid image'
          />
          <figcaption className='ui container'>
            Nicht nur Glace: Jeder von uns wirft jede Woche zwei Kilogramm Essen
            weg. Dabei ist es sehr einfach,{' '}
            <Scrollchor animate={{ offset: -10 }} to='#foodwaste'>
              &rarr;Foodwaste
            </Scrollchor>{' '}
            zu vermeiden. (Bild: Cultura/Andrea Bakacs)
          </figcaption>
        </figure>

        <Waypoint scrollableAncestor={window} onEnter={(event) => {
          if (event.previousPosition === Waypoint.below) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              'event': '80ContentRead'
            }
            )
          }
        }} />

        <div className='ui tipps container' id='ernaehrung'>
          <h2>Ernährung</h2>
          <div className='ui three column doubling stackable masonry grid'>

            <div className='column'>
              <div className='ui fluid card' id='fleisch'>
                <Tipp title='Fleisch' impact='❋❋❋❋❋'>
                  Fleisch ist nicht per se böse. Es ist als Nahrungsmittel nur
                  schaurig ineffizient. Tiere stehen in der Nahrungskette weiter
                  oben als Pflanzen. Damit wir ein Tier essen können, muss
                  dieses sehr viele Pflanzen gefressen haben. Für 1 Kilo Fleisch
                  braucht es bis zu 20 Kilo Futter. Auch andere Tierprodukte wie
                  Milch, Butter, Käse und Eier haben eine schlechte
                  Umweltbilanz. Darum ist der Ernährungsfussabdruck von
                  Vegetariern um 24 Prozent, von Veganern gar um 40 Prozent
                  kleiner als jener von Fleischessern. Wir müssen aber nicht
                  gleich alle zu Vegis werden. Zweimal Fleisch pro Woche liegt
                  nach den Gesetzen der Nachhaltigkeit drin{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#ziele-setzen'>
                    [&rarr;Ziele setzen]
                  </Scrollchor>
                  . Bei der Frage «Welches Fleisch?» wird es kompliziert. Die
                  natürliche Antwort in der Schweiz wäre eigentlich «Rind». Kühe
                  sind eine geniale Erfindung: Sie verwandeln Gras, das dem
                  Menschen als Nahrungsmittel nicht zugänglich ist, in Milch und
                  Fleisch. Und zwar auch auf Flächen, die für den Ackerbau zu
                  steil oder zu hoch gelegen sind. Nebenbei schützen sie auch
                  noch die Alpweiden vor Vergandung, was wichtig ist für die
                  Biodiversität. Doch es gibt ein Problem mit den Rindern: Beim
                  Wiederkäuen stossen sie grosse Mengen an Methan aus, ein
                  extrem wirksames Klimagas. Gemessen an der Umweltbelastung pro
                  Kilo, ist Rindfleisch so ziemlich das Schlechteste, was man
                  überhaupt essen kann. Besonders negativ ist dabei ausgerechnet
                  Fleisch aus tierfreundlicher Weidehaltung: Ohne Zufütterung
                  wachsen die Kühe langsamer und rülpsen darum mehr Methan, bis
                  sie ihr Endgewicht erreicht haben. Es ist verzwickt, und eine
                  einfache Lösung gibt es nicht. Faustregel: Wenn Sie es
                  wirklich schaffen, auf zweimal Fleisch pro Woche
                  runterzukommen, dann greifen Sie zu Rind oder Lamm aus
                  Weidehaltung. Wenn Sie hingegen wissen, dass Sie vom Fleisch
                  nicht lassen können, und wenn Ihnen das Tierwohl nicht so
                  wichtig ist, dann bleiben Sie bei Schwinigs oder Poulet aus
                  der Intensivhaltung. Es richtet zumindest punkto Klima weniger
                  Schaden an.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card' id='foodwaste'>
                <Tipp title='Foodwaste' impact='❋❋❋❋'>
                  Üble Sache. Jeder und jede von uns wirft wöchentlich zwei Kilo
                  Lebensmittel weg. Sie nicht? Führen Sie eine Zeit lang ein
                  Abfalltagebuch, das öffnet die Augen. Auch ein verfaulter
                  Apfel, den wir auf den Kompost schmeissen, ist Foodwaste, denn
                  er hat Transportenergie, Dünger und allenfalls Spritzmittel
                  verbraucht (es sei denn, er stammt aus dem eigenen Garten).
                  Wichtig und oft vergessen: Die Resten, die wir auf dem Teller
                  zurücklassen. Kultivieren Sie den Doggybag! Kein Wirt, kein
                  Gastgeber wird es Ihnen übel nehmen, wenn Sie sich etwas
                  einpacken, im Gegenteil. Gewöhnen Sie sich an, selber einen
                  geeigneten Behälter mitzunehmen, wenn Sie eine schwache
                  Esserin sind – man will ja nicht jedes Mal den Kellner
                  bemühen. Ein paar Tipps für zu Hause und im Laden: Die alten
                  Lebensmittel im Kühlschrank nach vorne stellen, die neuen nach
                  hinten. Sich auf die Nase verlassen statt auf das Ablaufdatum.
                  Sich ein Repertoire an Restenrezepten zulegen (Teigwarensalat,
                  Fotzelschnitten, Ofenguck). Statt einzukaufen: alle Zutaten,
                  die man noch im Kühlschrank findet, zusammen mit dem Stichwort
                  «Rezept» googeln, es kommt meist etwas Sinnvolles heraus. Wenn
                  man trotzdem einkaufen geht: eine Liste machen. Nicht mit
                  leerem Magen losziehen, dann kauft man weniger. Im Laden die
                  Milch mit dem knappsten Verfalldatum nehmen, wenn man sie
                  ohnehin bald aufbraucht.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Gastronomie' impact='❋❋❋❋'>
                  Es ist paradox: Viele Menschen achten sehr bewusst darauf, was
                  sie einkaufen – bestellen aber im Restaurant oder am
                  Imbissstand, ohne viel nachzudenken. Dabei ist der Fussabdruck
                  der Ausserhausverpflegung keineswegs kleiner als daheim: Etwa
                  die Hälfte der Hauptmahlzeiten und auch die Hälfte des
                  Fleisches konsumieren wir auswärts, Tendenz steigend. Gewöhnen
                  Sie sich an, in der Gastronomie die gleichen Massstäbe
                  anzulegen wie im Laden. Die Massstäbe sind: wenig{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#fleisch'>
                    &rarr;Fleisch
                  </Scrollchor>{' '}
                  und wenig Milchprodukte, keine Flugware, kein Gemüse aus
                  geheizten Gewächshäusern, auf{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#regional'>
                    &rarr;Regional
                  </Scrollchor>{' '}
                  und{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#saisonal'>
                    &rarr;Saisonal
                  </Scrollchor>{' '}
                  achten. Lesen Sie das Kleingedruckte in der Speisekarte,
                  fragen Sie nach.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card' id='fisch'>
                <Tipp title='Fisch' impact='❋❋❋'>
                  Kürzestform der Geschichte des Speisefischs der letzten
                  fünfzig Jahre: Der Pro-Kopf-Konsum hat sich verdoppelt, die
                  Populationen haben sich halbiert. Im grossen Stil sind auch
                  Fischzuchten ökologisch problematisch. Wie man es auch dreht
                  und wendet, mehr als zweimal Fisch pro Monat gibt die Welt
                  nicht her. Am besten greifen Sie zu einheimischen Arten oder
                  zu Zuchtkarpfen{' '}
                  <a href='https://www.dasmagazin.ch/2019/03/29/fischfleisch'>
                    [&rarr; Kolumne von Christian Seiler]
                  </a>
                  .
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card' id='kaffee'>
                <Tipp title='Kaffee' impact='❋❋❋'>
                  Hat den grössten Fussabdruck aller Getränke. Jede Tasse
                  entspricht einer Autofahrt von einem Kilometer. Insgesamt
                  macht Kaffee 9 Prozent unserer Ernährungsumweltbelastung aus.
                  Eine einfache Lösung gibt es nicht. Der einzige sinnvolle Rat:
                  Auf Tee umsteigen, der ist weniger umweltschädlich.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card' id='saisonal'>
                <Tipp title='Saisonal' impact='❋❋❋'>
                  Bringts. Wer darauf achtet, erwischt garantiert keine
                  Treibhaus- oder Flugware. Insbesondere{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#maenner'>
                    &rarr;Männer
                  </Scrollchor>{' '}
                  haben oft keine Ahnung, was bei uns wann Saison hat. Hier kann
                  man nachschauen:{' '}
                  <a
                    className='external'
                    href='https://www.wwf.ch/de/fruechte-und-gemueseratgeber'
                  >
                    wwf.ch
                  </a>
                  . Einheimisches Gemüse ausserhalb der Saison stammt meist aus
                  beheizten Gewächshäusern, was ihnen eine miserable
                  Energiebilanz gibt. Immerhin: Coop und Migros wollen in den
                  nächsten Jahren sukzessive auf die fossile Beheizung von
                  Gewächshäusern verzichten. Es gibt aber auch gut lagerbares
                  hiesiges Gemüse, das man ohne grosse Bedenken das ganze Jahr
                  kaufen kann, beispielsweise Zwiebeln, Lauch, Rüebli,
                  Kartoffeln, Randen. Einheimische Früchte frisch ab Baum, etwa
                  Äpfel, Birnen oder Kirschen, haben wohl von allen
                  Lebensmitteln die geringste Umweltbelastung pro Kalorie. Mit
                  zunehmendem Abstand zur Saison läppert sich aber die Energie
                  für die Kühlung zusammen, sodass ein einheimischer Lagerapfel
                  im Frühling nicht mehr zwingend die bessere Ökobilanz hat als
                  ein mit dem Schiff aus Neuseeland importierter Frischapfel.
                  Die ökologischste Variante ist ohnehin, im Herbst grössere
                  Mengen von Äpfeln oder auch Gemüse zu kaufen und auf dem
                  Balkon, im Keller oder in einer sogenannten Erdmiete im Garten
                  zu lagern. Das geht gut bis im März und kostet null Energie,
                  braucht aber ein wenig Fingerspitzengefühl. Detailwissen gibts
                  zum Beispiel hier:{' '}
                  <a
                    className='external'
                    href='http://www.hausinfo.ch/de/home/garten/aktuelle_gartenarbeiten/herbst/obst-gemuese-lagern.html'
                  >
                    hausinfo.ch
                  </a>
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Wein' impact='❋❋❋'>
                  Ist fast so schlimm wie{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#kaffee'>
                    &rarr;Kaffee
                  </Scrollchor>
                  . Die gute Nachricht: Beim Wein gibt es eine Lösung. Sein
                  übergrosser Fussabdruck rührt nämlich daher, dass Reben
                  anfällig für Pilzkrankheiten sind. 60 Prozent der Fungizide
                  werden in Europa in Rebbergen ausgebracht – obwohl die nur 5
                  Prozent der Anbaufläche ausmachen. Die Ökobilanz von
                  Biowinzern ist übrigens nicht besser: Statt synthetische
                  Mittel spritzen sie Kupfer, ein Schwermetall, das sich im
                  Boden anreichert. Die Lösung besteht in neu entwickelten,
                  pilzwiderstandsfähigen Rebsorten, sogenannten Piwi-Weinen. Sie
                  verbreiten sich immer mehr, und mittlerweile rümpfen auch die
                  Kenner nicht mehr präventiv die Nase, wenn man eine Flasche
                  öffnet. Die Umstellung auf Piwi kann die Umweltfolgen des
                  Weinkonsums halbieren. Wem die Artenvielfalt wichtig ist, der
                  achtet zusätzlich auf das Label «Delinat».{' '}
                  <a
                    className='external'
                    href='https://www.delinat.com/piwi.html'
                  >
                    delinat.com
                  </a>
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card' id='mineralwasser'>
                <Tipp title='Mineralwasser' impact='❋❋'>
                  Wer sich unterwegs eine Flasche kauft, muss kein schlechtes
                  Gewissen haben. Zu einem relevanten Umweltfaktor wird
                  Mineralwasser erst dadurch, dass wir zu Hause und im Büro
                  unglaubliche Mengen davon in uns hineinschütten, nämlich 115
                  Liter pro Kopf und Jahr, oft in PET verpackt und mit dem Auto
                  transportiert. Die gute Nachricht ist, dass es sich um ein
                  Problem handelt, das Sie ultraleicht aus der Welt schaffen
                  können: Trinken Sie Hahnenwasser! Es belastet die Umwelt etwa
                  500-mal weniger als Mineralwasser. Nein, Hahnenwasser ist
                  nicht ungesund, verseucht oder sonst bedenklich. Es ist exakt
                  genau gleich gut wie Mineralwasser. Und man spart erst noch
                  Geld damit.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card' id='regional'>
                <Tipp title='Regional' impact='❋❋'>
                  Konsumpatriotismus ist Mode, wird aber manchmal überschätzt.
                  Eine konsequente Umstellung auf regionale Nahrungsmittel
                  reduziert den Ernährungsfussabdruck um 4 Prozent. Das ist
                  nicht nichts, aber sechsmal weniger als ein Wechsel zu Vegi{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#fleisch'>
                    [&rarr;Fleisch]
                  </Scrollchor>
                  . Entscheidend ist, keine eingeflogenen Lebensmittel (z. B.
                  Mangos oder Papayas) zu kaufen, sie sind für das Klima bis zu
                  zehnmal so schädlich wie mit dem Schiff transportierte. Coop
                  und Migros kennzeichnen sie mit dem Vermerk «by air». Mit
                  Ausnahme der Flugwaren spielt der Transport für die
                  Gesamtökobilanz aber eine geringe Rolle, viel wichtiger ist
                  die Anbaumethode. Im Winter erzeugt eine im beheizten
                  Gewächshaus produzierte Schweizer Tomate zehnmal so viel
                  Klimagase wie eine Freilufttomate aus Andalusien{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#saisonal'>
                    [&rarr;Saisonal]
                  </Scrollchor>
                  . Dafür ist die spanische Tomate wegen der Bewässerung
                  problematisch{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#wasser'>
                    [&rarr;Wasser]
                  </Scrollchor>
                  . Die ökologisch korrekte Wintertomate ist daher jene aus der
                  Büchse.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Hofläden' impact='❋'>
                  An sich eine gute Sache. Nur liegen sie meist abseits und
                  generieren Mehrverkehr. Das Bauernbrot oder auch die selbst
                  gepflückten Erdbeeren bekommen eine grausam schlechte
                  Ökobilanz, wenn Sie ihretwegen extra zwei Tonnen Blech
                  bewegen. Nehmen Sie das Velo!
                </Tipp>
              </div>
            </div>


            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Palmöl' impact='❋'>
                  Steckt in fast jedem verarbeiteten Lebensmittel. Kostet
                  Regenwald, aber der Umstieg auf andere Öle wäre eine
                  Verschlimmbesserung, da beispielsweise Kokospalmen beinahe
                  fünfmal so viel Platz pro Liter Ertrag brauchen wie Ölpalmen.
                  Palmöl mit Nachhaltigkeitssiegel ist auch nicht wirklich
                  nachhaltig. Mit der App CodeCheck kann man verarbeitete
                  Produkte wie Glace, Guetzli, Frischbackwaren, Fertigpizza,
                  Schokolade oder Margarine auf ihren Palmölgehalt überprüfen.
                  Aber wie gesagt, andere Öle haben auch keine bessere
                  Ökobilanz. Der einzige Rat, den man momentan geben kann:
                  Kaufen Sie wenn möglich Frischwaren.
                </Tipp>
              </div>
            </div>

          </div>
        </div>

        <figure className={'ui vertical padded segment'}>
          <img
            src={diverses.sources['1280w']}
            srcSet={diverses.srcSet}
            sizes={'100vw'}
            alt='An Wasser herrscht an sich kein Mangel. In manchen Regionen jedoch schon, etwa weil wir im Winter unbedingt frische Tomaten wollen.'
            className='ui fluid image'
          />
          <figcaption className='ui container'>
            An{' '}
            <Scrollchor animate={{ offset: -10 }} to='#wasser'>
              &rarr;Wasser
            </Scrollchor>{' '}
            herrscht an sich kein Mangel. In manchen Regionen jedoch schon, etwa
            weil wir im Winter unbedingt frische Tomaten wollen. (Bild: Getty
            Images)
          </figcaption>
        </figure>

        <div className='ui tipps container' id='diverses'>
          <h2>Kommunikation & Diverses</h2>
          <div className='ui three column doubling stackable masonry grid'>
            <div className='column'>
              <div className='ui fluid card' id='rebound-effekt'>
                <Tipp title='Rebound-Effekt ' impact='❋❋❋❋❋'>
                  Es ist extrem wichtig, ihn zu verstehen, denn er macht so
                  manche gute Bemühung zunichte. Der Rebound-Effekt erklärt
                  zunächst, warum der Gesamtenergieverbrauch ständig steigt,
                  obwohl doch die einzelnen Geräte immer effizienter werden.
                  Krasses Beispiel: Vor vierzig Jahren verbrauchte eine einzelne
                  Rechenoperation mit dem Computer eine Million Mal mehr Energie
                  als heute. Trotzdem verdoppelt sich der Energieverbrauch der
                  Informatik-Infrastruktur etwa alle fünf Jahre. Weil
                  Rechenoperationen so billig, so bequem, so nützlich geworden
                  sind, dass ihre Zahl explodiert ist. Es handelt sich um eine
                  Rückkopplung: Der Effizienzgewinn ermöglicht Verschwendung,
                  die den Gewinn dann teilweise oder ganz zunichte macht. Man
                  findet dieses Phänomen überall. So lassen etwa die Leute
                  typischerweise das{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#licht'>
                    &rarr;Licht
                  </Scrollchor>{' '}
                  länger brennen, wenn sie Sparlampen eingesetzt haben – eine
                  Betriebsstunde ist ja jetzt billiger. Es geht auch indirekt:
                  Mit dem Geld, das ich bei den Lampen spare, kaufe ich mir
                  einen grösseren Fernseher. Und schon ist der Gewinn für die
                  Umwelt wieder futsch. Der Rebound-Effekt hat eine starke
                  moralische Komponente: So legen viele Menschen mehr Kilometer
                  zurück, sobald sie ein sparsames oder elektrisches Auto
                  gekauft haben. Offenbar trägt jeder von uns eine Art
                  moralisches Konto in sich, das ihm für jede gute Tat eine
                  Sünde erlaubt. Darum glauben auch viele Leute, sie täten genug
                  für die Umwelt, wenn sie Aludeckeli sammeln, und müssten sich
                  nicht weiter bemühen. Ins gleiche Kapitel gehört, dass sich
                  Reiche mit schlechtem Gewissen gern einen Tesla kaufen, um
                  ihren verschwenderischen Lebensstil quasi reinzuwaschen. Was
                  können Sie tun? Seien Sie sich des Effekts bewusst, das hilft
                  schon viel. Bemühen Sie sich um Objektivität, kontrollieren
                  Sie sich: Ist der Energieverbrauch mit der neuen Heizung
                  wirklich zurückgegangen{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#messen'>
                    [&rarr;Messen]
                  </Scrollchor>
                  , oder drehe ich nun die Temperatur höher? Setzen Sie sich
                  eine Belohnung aus, wenn Sie die selbst gesteckten Umweltziele
                  erreichen{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#ziele-setzen'>
                    [&rarr;Ziele setzen]
                  </Scrollchor>
                  . So können Sie Ihr inneres Moralkonto auf relativ
                  unschädliche Weise wieder ausgleichen.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card' id='messen'>
                <Tipp title='Messen' impact='❋❋❋❋'>
                  Ein grosses Hindernis für den Umweltschutz: Für viele Leute
                  wirken die Probleme abstrakt. Der Klimawandel zeigt sich vorab
                  in Statistiken, und auch die Auswirkungen des eigenen Tuns
                  sind selten direkt sichtbar. Darum kann es nützlich sein, ein
                  Feedback zu seinem Verhalten zu bekommen. Ein Beispiel sind
                  sogenannte Smart Meters zur Messung des Stromverbrauchs. Dank
                  der zugehörigen App sieht man direkt auf dem Handy, wie der
                  Verbrauch sinkt, wenn man den Radiator runterdreht. Eine
                  Studie hat gezeigt, dass zum Beispiel der Energieverbrauch
                  beim Duschen dauerhaft um 22 Prozent zurückgeht, wenn einem
                  eine Anzeige am Duschkopf den aktuellen Warmwasserkonsum
                  unmittelbar vor Augen führt. Ein einfacher und sehr
                  hilfreicher Schritt ist es auch, mit einem Footprintrechner
                  die Klimawirkung des eigenen Lebensstils zu bestimmen:{' '}
                  <a className='external' href='http://www.footprint.ch'>
                    footprint.ch
                  </a>
                  . Dauert nur eine Viertelstunde. Nid pschiisse, sonst kann man
                  es gleich sein lassen. Sie werden vielleicht überrascht sein,
                  wie schlecht Sie abschneiden, gerade wenn Sie das Gefühl
                  haben, eigentlich ein umweltbewusster Mensch zu sein. Immerhin
                  versetzt einem die Selbstanalyse womöglich den entscheidenden
                  Schubs, endlich etwas zu verändern. Der Footprintrechner zeigt
                  auch gleich an, in welchen Bereichen man das grösste
                  Verbesserungspotenzial hat.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card' id='ziele-setzen'>
                <Tipp title='Ziele setzen' impact='❋❋❋❋'>
                  Es ist nicht leicht, sein Leben zu ändern. Wenn Sie wirklich
                  gewillt sind, etwas für die Umwelt zu tun, dann wählen Sie ein
                  Gebiet mit einem grossen Impact-Faktor, also etwa{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#autofahren'>
                    &rarr;Autofahren
                  </Scrollchor>
                  ,{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#fleisch'>
                    &rarr;Fleisch
                  </Scrollchor>{' '}
                  essen,
                  <Scrollchor animate={{ offset: -10 }} to='#fliegen'>
                    &rarr;Fliegen
                  </Scrollchor>{' '}
                  oder{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#heizen'>
                    &rarr;Heizen
                  </Scrollchor>
                  . Nehmen Sie das, was Ihnen am wenigsten wehtut. Setzen Sie
                  sich ein Ziel. Und fangen Sie klein an: ein autofreier oder
                  ein fleischfreier Tag pro Woche, ein flugloses Jahr. Je
                  konkreter der Vorsatz ist, desto eher halten Sie ihn ein:
                  «Immer dienstags nehme ich das Velo.» Kaufen Sie einen Helm,
                  bringen Sie das Velo in Schuss. Notieren Sie sich Ihr Ziel,
                  oder erzählen Sie Leuten davon, das verpflichtet. Noch besser:
                  Schliessen Sie sich zusammen mit einem Freund, mit einer
                  Arbeitskollegin, und verfolgen Sie das Ziel gemeinsam. Das
                  wird Sie davon abhalten, im entscheidenden Moment doch wieder
                  zum Autoschlüssel zu greifen. Wenn Sie die Anfangshürde einmal
                  genommen haben, können Sie die Dosis steigern und Ihr
                  Engagement auf andere Felder ausweiten.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Teilen' impact='❋❋❋'>
                  Gute Sache. Und funktioniert mit fast allem: Autos, Kleider,
                  Maschinen, Fertigkeiten. Besonders sinnvoll bei Geräten, die
                  wir selten brauchen – eine typische Bohrmaschine läuft in
                  ihrem Leben angeblich nur zwölf Minuten. Auch das
                  Wohnungsteilen wäre an sich eine gute Idee, doch kommt hier
                  ein starker{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#rebound-effekt'>
                    &rarr;Rebound-Effekt
                  </Scrollchor>{' '}
                  ins Spiel: Es hat das Übernachten so bequem und billig
                  gemacht, dass die Leute deswegen mehr reisen und konsumieren.
                  Insgesamt hat Airbnb daher zu einer Steigerung des
                  Energieverbrauchs geführt.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card' id='vorbilder'>
                <Tipp title='Vorbilder' impact='❋❋❋'>
                  Es fehlt in unserer Gesellschaft an grünen Vorbildern. Gewiss,
                  Ökopedanten und Sauberfrauen können nerven. Viel schlimmer
                  aber sind jene gar nicht so seltenen Zeitgenossen, die Wasser
                  predigen und Kerosin trinken. Zu grossen Klimakonferenzen
                  fliegen gern mal zwanzigtausend Leute ein, Umweltjournalisten
                  jetten nach Grönland, um den Gletschern beim Schmelzen
                  zuzuschauen, und auch Vogelschützer befliegen gern hinterste
                  Winkel der Welt, um die letzten Exemplare einer aussterbenden
                  Gattung aufzuscheuchen. Bemerkt denn niemand diesen
                  Widerspruch? Immerhin, Greta Thunberg bewegt sich ökologisch
                  korrekt mit dem Zug. Aber schon eine ihrer Schweizer
                  Mitstreiterinnen, 17-jährig, gibt als ihr Hobby «Reisen» an,
                  gerne auch nach Übersee, und das keineswegs mit dem Tretboot.
                  Wie geht das mit der Forderung nach null Treibhausgas bis 2030
                  zusammen? Der entstehende Eindruck ist fatal. Denn die Leute
                  denken sich: Wenn nicht mal die sich daran halten, warum
                  sollte dann ich?
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Reden' impact='❋❋'>
                  Ökologisch handelnde Menschen stecken in einem Dilemma:
                  Eigentlich würden sie gern über ihr Verhalten reden, denn
                  sonst können sie ja niemanden damit anstecken{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#vorbilder'>
                    [&rarr;Vorbilder]
                  </Scrollchor>
                  . Doch manche Leute verdrängen Umweltthemen instinktiv und
                  reagieren allergisch, wenn man sie darauf anspricht – niemand
                  wird gern an seine Unzulänglichkeit erinnert. Ein Trick, der
                  hier vielleicht helfen kann: Hängen Sie Ihre ökologische
                  Überlegenheit nicht an die grosse Glocke. Sprechen Sie die
                  Themen an, aber reden Sie nicht nur von Ihren Erfolgen,
                  sondern vor allem von Ihrer eigenen Unvollkommenheit, von
                  Ihrem Kampf mit dem inneren Schweinehund. Spezialtipp für
                  Frauen, die möchten, dass ihr Partner{' '}
                  <Scrollchor animate={{ offset: -10 }} to='#maenner'>
                    [&rarr;Männer]
                  </Scrollchor>{' '}
                  weniger Fleisch isst: Reden Sie nicht darüber, kochen Sie
                  einfach vegetarisch. Wenn es gut schmeckt, wird er es gar
                  nicht merken.
                </Tipp>
              </div>
            </div>

            <div className='column'>
              <div className='ui fluid card'>
                <Tipp title='Reminder' impact='❋❋'>
                  Heften Sie kleine Zettel an strategisch wichtige Punkte, die
                  Sie im entscheidenden Moment sehen. Beim Lichtschalter: «Licht
                  aus!» Am Kühlschrank: «Resten essen!» An der Waschmaschine:
                  «Ökoprogramm!» Hört sich doof an. Aber es wirkt.
                </Tipp>
              </div>
            </div>
          </div>
        </div>

        <Waypoint scrollableAncestor={window} onLeave={(event) => {
          if (event.currentPosition === Waypoint.above) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              'event': 'contentBottom'
            }
            )
          }
        }} />

        <div className='ui text container readmore'>
          <h3>Zum Nachlesen</h3>
          <p>
            P. Pinzler, G. Wessel: «VIER FÜRS KLIMA. Wie unsere Familie
            versucht, CO<sub>2</sub>-neutral zu leben», Droemer Verlag, 2018.
            Eine Familie will ihren ganz persönlichen Beitrag zum Kampf gegen
            den Klimawandel leisten – und schafft es, ihren CO<sub>2</sub>
            -Jahresausstoss um immerhin 31 Prozent zu senken. Wir leiden mit,
            wenn die Familie schweren Herzens auf die Griechenland-Ferien
            verzichtet und stattdessen in die französischen Alpen fährt. Es ist
            ein ehrliches Buch, weit weg von den Lifestyle-Fibeln, wie man sie
            in diesem Genre auch manchmal findet. Und es macht Mut, denn die
            Familie verliert ihre Lebensfreude keineswegs, ganz im Gegenteil.
          </p>
          <p>
            G. Klaus, N. Gattlen: «NATUR SCHAFFEN. Ein praktischer Ratgeber zur
            Förderung der Biodiversität in der Schweiz», Haupt Verlag, 2016. Ein
            Buch voller Tipps und Anregungen, die zeigen, wie die verbliebene
            Artenvielfalt geschützt werden kann – im Haus, im Garten, in
            Gemeinde und Schule. Erscheint demnächst bereits in zweiter
            Auflage, ist vorbestellbar.
          </p>
        </div>

        <section
          className='ui fitted vertical segment'
          style={{ paddingTop: '0' }}
        >
          <div
            className='ui text container user-feedback-container no-marg'
            style={{ margin: '0 auto', paddingTop: '0px' }}
          >
            <UserFeedback
              theme='simple'
              starIcon='star'
              articleId={this.props.articleId}
              starColor='#6acbb1'
              fontColor='#ccc'
              backgroundColor='#fff'
              starAmount='5'
              title='Wie war&apos;s?'
              questions={[
                'Wie hilfreich waren die 75 Ideen?',
                'Wie gefällt Ihnen die Gestaltung?'
              ]}
            />
          </div>
        </section>

        <Waypoint scrollableAncestor={window} onLeave={(event) => {
          if (event.currentPosition === Waypoint.above) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              'event': 'pageBottom'
            }
            )
          }
        }} />

        <Footer
          articleId={ARTICLE_ID}
          publicationDate={this.state.publicationDate}
        />



      </div>
    )
  }
}

export default hot(module)(AppComponent)
